//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Observable } from 'rxjs';

//-================ IMPORTS FOR SERVICES ================-\\
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { LlamaIndexService } from 'src/app/Services/LlamaIndex/llama-index.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';

//-================ IMPORTS FOR CONSTANTS ================-\\
import { Download_Log_FIN } from 'src/app/Constants/Backlog/FIN/Download_Log_FIN';
import { Permission, Permissions } from 'src/app/Constants/Admin/Permissions';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { Key_Header_FIN } from 'src/app/Constants/Constants-FIN/Key-Header';
import { URLs } from 'src/environments/constants';

//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';

//-================ IMPORTS FOR INTERFACES ================-\\
import { FILE_CAP, FILE_CAP_Annexe, FILE_CAP_Annexe_ID } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { Annexe_ID, } from 'src/app/Interfaces/Libraries/Library-FIN-int/Create_WF/WorkFlow_FIN.interface';
import { Data_Check, Filter_Check_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_FIN.interface';
import { Annexe, FILE_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import { Group_Notification } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Group_Notification.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Same_File_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Same-File-FIN.interface';
import { TASK_ALL_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/All-Task-FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Data_VH_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Data_VH_FIN.interface';
import { Header_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Header_FIN.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { User_CDMS } from 'src/app/Interfaces/Interfaces-Global/User_CDMS.interface';
import { Permission_Folder_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Permissions/Permission_FIN.interface';
import { ModalService } from 'src/app/Services/Global/Modal/Libraries/Library-FIN/modal.service';
import { permissionSystemFolderFIN, PermissionSystemFolderFINType, tpermissionFolderFIN } from 'src/app/types/FIN/permissionFolderFIN.type';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { Table } from 'primeng/table';


@Component({
  selector: 'app-file-manager-lib-fin',
  templateUrl: './file-manager-lib-fin.component.html',
  styleUrls: ['./file-manager-lib-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/LibrayGlobal.css', '../../../../Styles/SharedFolder.scss'],
  standalone: false
})
export class FileManagerLibFINComponent implements OnInit {
  @ViewChild('dtFIN')
  dtFIN!: Table;
  @ViewChild('inputMassiveFIN')
  inputMassiveFIN!: ElementRef<HTMLInputElement>;
  @ViewChild('contextMenuPrcFIN')
  contextMenuPrcFIN?: any;
  private readonly STORAGE_MAIN_FILE_TYPE_FIN = 'FIN_MAIN_FILE_TYPE_UPLOAD';
  public UseOCR_LocalMassive: boolean = true;
  public UseOCR_CloudMassive: boolean = false;

  public ToggleOCR_LocalMassive(): void {
    this.UseOCR_LocalMassive = !this.UseOCR_LocalMassive;
    if (this.UseOCR_LocalMassive) {
      this.UseOCR_CloudMassive = false;
    }
  }

  public ToggleOCR_CloudMassive(): void {
    this.UseOCR_CloudMassive = !this.UseOCR_CloudMassive;
    if (this.UseOCR_CloudMassive) {
      this.UseOCR_LocalMassive = false;
    }
  }


  //-===================================== SECTION FORMS =====================================-\\

  //+===================== FORM ADD NEW FOLDER =====================+\\
  public FormAddFolderFIN: FormGroup = new FormGroup({
    NameFolderFIN: new FormControl('', [Validators.required, Validators.pattern(/^[^\\/:*?"<>|]*$/)]),
    InheritanceGA: new FormControl(false),
    Groups: new FormControl([]),
    OCR_Regex: new FormControl(''),
    OCR_Inheritance: new FormControl(true)
  });

  //+================== VARIABLES FOR MODAL FOLDER CONFIG ==================+\\
  public ShowAdvancedConfig: boolean = false;
  public isOpenGroupModal: boolean = false;
  public GroupsAvailable: any[] = [];
  public SearchGroup: string = '';
  public first_GA_Form: number = 0;
  public rows_GA_Form: number = 5;
  public CurrentReviewerIndex: number = -1;

  //+===================== FORM ADD NEW FIN =====================+\\
  public FormFIN: FormGroup = new FormGroup({
    NameFIN: new FormControl('', [Validators.pattern(/.docx$|.doc$/), Validators.required]),
    Purpose: new FormControl({ value: '', disabled: true }, [Validators.pattern(/^[a-zA-Z0-9+ ñÑ.áéíóúÁÉÍÓÚäëïöüÄËÏÖÜüÜ,()\-:;/_'\s\u0301\u0303\u0308]{5,}/), Validators.required]),
    Code: new FormControl({ value: '', disabled: true }, Validators.required),
    Revision_No: new FormControl({ value: 0, disabled: true }, [Validators.required, Validators.pattern(/^([1-9]$|[1-9][0-9]$)/)]),
    Approver1: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver2: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver3: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver4: new FormControl({ value: '', disabled: true }, Validators.required),

  });

  //?======== GET VALUE NAMEFIN ========?\\
  get NameFileFIN() {
    return this.FormFIN.controls['NameFIN'];
  }


  //+===================== FORM UPDATE FIN =====================+\\
  public FormFINUpdate: FormGroup = new FormGroup({
    NameFIN: new FormControl('', [Validators.pattern(/.docx$|.doc$/), Validators.required]),
    Purpose: new FormControl({ value: '', disabled: true }, [Validators.pattern(/^[a-zA-Z0-9+ ñÑ.áéíóúÁÉÍÓÚäëïöüÄËÏÖÜüÜ,()\-:;/_'\s\u0301\u0303\u0308]{5,}/), Validators.required]),
    Code: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver1: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver2: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver3: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver4: new FormControl({ value: '', disabled: true }, Validators.required),
  });

  //?======== GET VALUE NAMEFIN IN UPDATE ========?\\
  get NameFileFINUpdate() {
    return this.FormFINUpdate.controls['NameFIN'];
  }


  //+===================== FORM RENAME FILE OR DIRECTORY =====================+\\
  public FormRenameFD: FormGroup = new FormGroup({
    NameRename: new FormControl('', [Validators.required, Validators.pattern(/^[^\\/:*?"<>|]*$/)])
  })

  //-========================= SECTION VARIABLES =========================-\\

  //+================== HEADERS ==================+\\
  public Key_Header_FIN = Key_Header_FIN;
  public Header_Routes: string[] = ['raiz'];
  public FIN_Table_Headers: Header_FIN[] = [];

  //+================== FILTERS ==================+\\
  public FIN_Filter: string = '';


  //+================== VARIABLES FOR GLOBAL NAVIGATION ==================+\\
  public NumberTopL: number = 0;
  public ID_Folder_Level: number = 0;
  public Route_Level_Global: string = '';


  //+================== VARIABLES TOTALS ==================+\\
  public TotalFoldersF: number = 0;
  public TotalFilesFIN: number = 0;

  // --- LÓGICA DE VISTA PREVIA ---
  public showPreview: boolean = false;
  public previewFileName: string = '';
  public previewFileUrl: string = '';
  public previewFileExtension: string = '';

  // --- LÓGICA DE MOVIMIENTO (SIDEBAR) ---
  public Right_Sidebar_Visible: boolean = false;


  //+================== VARIABLES FOR GROUPS NOTIFICATIONS ==================+\\
  public Group_Notification: Group_Notification[] = [];


  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;
  public MainFileTypeFIN: string = 'word';
  public MainFileTypeOptionsFIN: { Label: string, Value: string }[] = [
    { Label: 'Word (.doc/.docx)', Value: 'word' },
    { Label: 'PDF (.pdf)', Value: 'pdf' },
    { Label: 'Excel (.xls/.xlsx/.csv)', Value: 'excel' },
    { Label: 'PowerPoint (.ppt/.pptx)', Value: 'powerpoint' },
    { Label: 'Imagen (.png/.jpg/.jpeg...)', Value: 'image' },
    { Label: 'Texto (.txt/.rtf/.md)', Value: 'text' },
    { Label: 'Cualquier archivo', Value: 'any' },
  ];

  //+================== VARIABLES FILES ==================+\\
  public FileAuxAddFIN: FILE_CAP = { FileData: null, FileName: '' };
  public FileAuxUpdFIN: FILE_CAP = { FileData: null, FileName: '' };



  public FileAuxAddFIN_Annexes: FILE_CAP_Annexe[] = [];
  public FileAuxUpdFIN_Annexes: FILE_CAP_Annexe_ID[] = [];
  public FileAuxPropeties_Anne: FILE_CAP_Annexe_ID[] = [];


  public FileAuxUpdFIN_Annexe_Update: FILE_CAP_Annexe_ID = { ID: 0, FileData: '', FileName: '', Extension: '', Status: 0, Consecutive: 0, UpdateAnnexe: { FileData: '', FileName: '', Extension: '' } };
  public FileAuxUpdFIN_Annexe_Properties: FILE_CAP_Annexe_ID = { ID: 0, FileData: '', FileName: '', Extension: '', Status: 0, Consecutive: 0, UpdateAnnexe: { FileData: '', FileName: '', Extension: '' } };

  //+================== VARIABLES CREDENTIALS ==================+\\
  public ID_User_BD: number = Number(localStorage.getItem('ID_U_DB')) || 0;


  //+================== VARIABLE PERMISION ==================+\\
  public Permission_FMF: Permission_Folder_FIN = {
    ID: 0,
    Permission: [],
    Folder: { ID: 0, Name: '', ID_Folder_Top: 0, status: 0, Directory: false, Inheritance: 0, InheritanceGA: 0, Optional_Approvers: 0 },
    Users_Groups_For_Role:
    {
      G_Approvers_1: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_2: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_3: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_4: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
    }
  };
  public PermissionFIN: PermissionSystemFolderFINType = permissionSystemFolderFIN;

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;


  //+================== VARIABLES GLOBAL FILES FIN ==================+\\
  public All_Task_FIN: number = 0;
  public All_FAF_FIN: FILE_FIN[] = [];
  public SelectedALL_FAF_FIN!: FILE_FIN[];
  public selectedItemToMove: any = null;
  public selectedItemsToMove: any[] = [];
  public FFIN_Select_CM: FILE_FIN = {
    ID: 0,
    Extension: '',
    Name: '',
    Code: '',
    Purpose: '',
    Revision_No: 0,
    Status: 0,
    ID_Folder: 0,
    DynamicApprovers: [],
    Annexes: [],
    Date_Created: null,
    Date_Expiration: null,
    ID_Contributor: 0,
    Contributor_Name: '',
    ID_Previous_Version: null,
    ID_Next_Version: null,
    Status_System: 0,
    Directory: false,
    Path: '',
  };

  public FILE_FIN_Properties: Data_VH_FIN = {
    ID: 0,
    Name: '',
    Extension: '',
    Code: '',
    Purpose: '',
    Revision_No: 0,
    Status: 0,
    Area: null,
    Shop: null,
    ID_Folder: 0,
    TaskApprover1: {
      ID: 0,
      ID_WF: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
      Comment: null,
      Date_Start: null,
      Date_End: null,
    },
    TaskApprover2: {
      ID: 0,
      ID_WF: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
      Comment: null,
      Date_Start: null,
      Date_End: null,
    },
    TaskApprover3: {
      ID: 0,
      ID_WF: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
      Comment: null,
      Date_Start: null,
      Date_End: null,
    },
    TaskApprover4: {
      ID: 0,
      ID_WF: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
      Comment: null,
      Date_Start: null,
      Date_End: null,
    },
    Date_Created: null,
    Date_Modification: null,
    Date_Expiration: null,
    Date_End: null,
    ID_Contributor: 0,
    ID_Previous_Version: null,
    ID_Next_Version: null,
    Status_System: 0,
    Annexes: [],
    DynamicApprovers: [],
    Contributor_Name: '',
    Directory: false,
    Path: null
  }

  //+================== VARIABLE FOR UPDATE PROPERTIES ANNEXE ==================+\\
  public annexeUpdateAux!: Annexe;
  public annexesErrorFM: Annexe[] = [];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  public ColorConfirm: string = '#20a8e1';
  public ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR ARCHIVES DUPLICATED ==================+\\
  public FilesFIN_Dup: Same_File_FIN[] = [];


  //+================== VARIABLES FOR KEY SNAPSHOTS ==================+\\
  public KeySnap: string = 'em';


  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_FIN = {
    Extension: [],
    Status: [],
    Revision_No: [],
    Approver1_Name: [],
    Approver2_Name: [],
    Approver3_Name: [],
    Approver4_Name: [],
    Contributor_Name: [],
  };

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;

  //+================== VARIABLES FOR ICONS ==================+\\
  public Icons_Status = [
    { Icon: 'fa-user-slash', Status: 0 },
    { Icon: 'fa-user-pen', Status: 1 },
    { Icon: 'fa-user-clock', Status: 2 },
    { Icon: 'fa-user-check', Status: 3 },
    { Icon: 'fa-user-xmark', Status: 4 },
    { Icon: 'fa-user-shield', Status: 5 },
    { Icon: 'fa-user-shield', Status: 6 },
    { Icon: 'fa-users-slash', Status: 7 },
  ];

  //+================== VARIABLES FOR ICONS ==================+\\
  public StatusExpired = [
    { StatusExpired: 1, Description: 'El proceso se encuentra con una fecha de vencimiento adecuado.' },
    { StatusExpired: 2, Description: 'El proceso se encuentra próximo a vencer, le faltan 3 meses.' },
    { StatusExpired: 3, Description: 'El proceso se encuentra vencido.' },
  ];

  // --- LÓGICA DE DRAG AND DROP ---
  public draggedItems: any[] = [];
  public dragOverFolderId: number | null = null;
  public dragOverBreadcrumbIndex: number = -1;
  public IsMultiSelectMode: boolean = false;

  public ToggleMultiSelectMode(): void {
    this.IsMultiSelectMode = !this.IsMultiSelectMode;
    if (!this.IsMultiSelectMode) {
      this.SelectedALL_FAF_FIN = [];
    }
  }

  public async DeleteSelectedItems() {
    if (!this.SelectedALL_FAF_FIN || this.SelectedALL_FAF_FIN.length === 0) return;

    const validItems = this.SelectedALL_FAF_FIN.filter(item => {
      const permissionKey = item.Directory ? this.PermissionFIN.deleteFolder : this.PermissionFIN.deleteFile;
      return this.UserRoleIn([permissionKey]);
    });

    const omittedCount = this.SelectedALL_FAF_FIN.length - validItems.length;

    if (validItems.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Acción no permitida',
        text: 'No tienes los permisos necesarios para eliminar los elementos seleccionados.',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false
      });
      return;
    }

    const result1 = await Swal.fire({
      title: '¿Está seguro de eliminar los elementos seleccionados?',
      text: `¡Se enviarán ${validItems.length} elementos a la papelera de reciclaje!${omittedCount > 0 ? `\n\n(Se omitirán ${omittedCount} elementos por falta de permisos)` : ''}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!',
      cancelButtonText: 'Cancelar'
    });

    if (result1.isConfirmed) {
      const resultCheck = await Swal.fire({
        title: 'Nuevamente ¿está seguro?',
        text: '¡Marque la casilla para eliminar los elementos!',
        icon: 'warning',
        input: 'checkbox',
        inputValue: 0,
        inputPlaceholder: 'Eliminar elementos',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
        cancelButtonText: 'Cancelar <i class="fa-solid fa-xmark"></i>',
        inputValidator: (result) => {
          return !result ? '¡Debes marcar la casilla para confirmar!' : null;
        }
      });

      if (resultCheck.isConfirmed && resultCheck.value) {
      let successCount = 0;
      let errorCount = 0;

      for (const item of validItems) {
        try {
          let res: any;
          if (item.Directory) {
            res = await firstValueFrom(this.Service_FIN.Delete_Folder({ ID_Folder: item.ID }));
          } else {
            const idWF = item.ID_WF ? item.ID_WF : item.ID;
            res = await firstValueFrom(this.Service_FIN.Move_FIN_To_Recycle_Bin({ ID_WF: idWF }));
          }

          if (res && res.success) {
            successCount++;
          } else {
            errorCount++;
          }
        } catch (error) {
          console.error("Error al eliminar", item.Name, error);
          errorCount++;
        }
      }

      this.ToggleMultiSelectMode();
      this.RefreshCurrentDirectory();

      if (errorCount === 0) {
        Swal.fire({
          title: 'Eliminación Exitosa',
          text: `Se enviaron correctamente a la papelera los ${successCount} elemento(s).`,
          icon: 'success',
          confirmButtonColor: this.ColorConfirm
        });
      } else if (successCount > 0) {
        Swal.fire({
          title: 'Eliminación Parcial',
          text: `Se enviaron a la papelera ${successCount} elemento(s), pero fallaron ${errorCount}.`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        });
      } else {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo eliminar ningún elemento. Contacte a soporte.',
          icon: 'error',
          confirmButtonColor: this.ColorConfirm
        });
      }
    }
  }
  }

  public RefreshCurrentDirectory(): void {
    this.GetInformationDiretory(this.Route_Level_Global);
  }

  // Lógica Touch DND
  public isTouchDragging = false;
  public touchDraggedItems: any[] = [];
  public touchX = 0;
  public touchY = 0;
  private touchTimer: any;
  private scrollInterval: any = null;

  //-========================= SERVICES =========================-\\

  public UserService = inject(UserDataService);
  public Service_FIN = inject(LibraryFINService);
  public ActivatedRouter = inject(ActivatedRoute);
  public Router = inject(Router);
  public PermissionFolder = inject(PermisionsFolderService);
  public ModalService = inject(ModalService);
  protected llamaService = inject(LlamaIndexService);
  protected generalCDMSService = inject(GeneralCDMSService);

  protected masterService = inject(LibraryMasterService);
  protected readonly FIN_LIB_SLUG = 'fin';

  constructor() {
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
    this.KeySnap = this.ActivatedRouter.snapshot.params['Key'];
  }

  public Get_Dynamic_Approver_Name(approvers: any[], keyHeader: string): string {
    if (!approvers || approvers.length === 0) return 'No Requerido';
    const match = `${keyHeader || ''}`.match(/\d+/);
    const UrLevel = match ? Number(match[0]) : NaN;
    const found = approvers.find((a: any) => a.ID_UR === UrLevel);
    // Evaluamos el 'Status' del Approver o simplemente su nombre.
    return found ? found.Name : 'No Requerido';
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'instant' });
    setTimeout(() => {
      const container = document.querySelector('.container-global');
      if (container) container.scrollTop = 0;
    }, 50);
    this.Sync_File_Type_Config_FIN();
    this.Load_component();
  }

  public Sync_File_Type_Config_FIN(): void {
    this.MainFileTypeFIN = this.Get_Selected_Main_File_Type_FIN();
    this.Apply_Main_File_Validators_FIN();
  }

  public Get_Selected_Main_File_Type_FIN(): string {
    const ConfigValue = localStorage.getItem(this.STORAGE_MAIN_FILE_TYPE_FIN);
    if (ConfigValue && this.MainFileTypeOptionsFIN.some(item => item.Value === ConfigValue)) {
      return ConfigValue;
    }

    return this.MainFileTypeFIN || 'word';
  }

  private Get_File_Name_Regex_FIN(fileType?: string): RegExp {
    const SelectedType = fileType || this.MainFileTypeFIN;
    switch (SelectedType) {
      case 'pdf':
        return /\.pdf$/i;
      case 'excel':
        return /\.(xls|xlsx|csv)$/i;
      case 'powerpoint':
        return /\.(ppt|pptx|pps|ppsx)$/i;
      case 'image':
        return /\.(png|jpe?g|gif|bmp|webp|svg)$/i;
      case 'text':
        return /\.(txt|rtf|md)$/i;
      case 'any':
        return /\.[^./\\]+$/;
      case 'word':
      default:
        return /\.(doc|docx)$/i;
    }
  }

  private Apply_Main_File_Validators_FIN(): void {
    const NameControlAdd = this.FormFIN.controls['NameFIN'];
    const NameControlUpdate = this.FormFINUpdate.controls['NameFIN'];

    // Para carga individual, permitimos cualquier archivo (o puedes restringir a lo básico si prefieres)
    // El usuario quiere "cualquier tipo de archivo" en la individual.
    const AnyFileRegex = /\.[^./\\]+$/;
    NameControlAdd.setValidators([Validators.pattern(AnyFileRegex), Validators.required]);
    NameControlUpdate.setValidators([Validators.pattern(AnyFileRegex), Validators.required]);

    NameControlAdd.updateValueAndValidity({ emitEvent: false });
    NameControlUpdate.updateValueAndValidity({ emitEvent: false });
  }

  public On_Main_File_Type_Change_FIN(): void {
    localStorage.setItem(this.STORAGE_MAIN_FILE_TYPE_FIN, this.MainFileTypeFIN);
    this.Sync_File_Type_Config_FIN();

    Swal.fire({
      icon: 'success',
      title: 'Configuración actualizada',
      text: `Ahora se permite cargar: ${this.MainFileTypeOptionsFIN.find(item => item.Value === this.MainFileTypeFIN)?.Label || 'Word (.doc/.docx)'}.`,
      confirmButtonColor: this.ColorConfirm
    });
  }

  public Get_Main_File_Accept_FIN(): string | null {
    const SelectedType = this.Get_Selected_Main_File_Type_FIN();
    switch (SelectedType) {
      case 'pdf':
        return '.pdf,application/pdf';
      case 'excel':
        return '.xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv';
      case 'powerpoint':
        return '.ppt,.pptx,.pps,.ppsx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';
      case 'image':
        return 'image/*,.png,.jpg,.jpeg,.gif,.bmp,.webp,.svg';
      case 'text':
        return '.txt,.rtf,.md,text/plain,text/markdown,application/rtf';
      case 'any':
        return null;
      case 'word':
      default:
        return '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }
  }

  public Get_Invalid_File_Message_FIN(): string {
    const SelectedType = this.Get_Selected_Main_File_Type_FIN();
    switch (SelectedType) {
      case 'pdf':
        return '¡Solo se aceptan archivos PDF!';
      case 'excel':
        return '¡Solo se aceptan archivos Excel (.xls/.xlsx/.csv)!';
      case 'powerpoint':
        return '¡Solo se aceptan archivos PowerPoint!';
      case 'image':
        return '¡Solo se aceptan archivos de imagen!';
      case 'text':
        return '¡Solo se aceptan archivos de texto!';
      case 'any':
        return '¡El archivo no es válido, verifique que tenga una extensión e intente nuevamente!';
      case 'word':
      default:
        return '¡Solo se aceptan archivos tipo Word!';
    }
  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_component(): Promise<void> {
    this.Load_Headers_FIN();
    this.Load_Groups();
    this.Load_Task();

    if (this.KeySnap != 'em') {

      const RouteDecode: string = decodeURIComponent(this.KeySnap);
      const Folder: string = RouteDecode.split('/').pop() || '';
      const ID_Folder: number = Number(Folder.split('§').shift());


      const ArrayRoute: string[] = RouteDecode.split('/');
      for (const Item of ArrayRoute) { this.Header_Routes.push(Item); this.NumberTopL += 1; }

      this.Route_Level_Global = RouteDecode;

      if (!isNaN(ID_Folder)) {

        this.CheckUserPermissionFolder(ID_Folder, RouteDecode);

      } else {
        Swal.fire({
          title: 'Ocurrió un error',
          text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
      }
    } else {

      this.SeeFolder_BreadCrum(0);
    }
  }

  //-================== FUNCTTION FOR LOAD HEADERS FIN ==================-\\
  private async Load_Headers_FIN(): Promise<void> {

    try {

      const ResHeaders: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Headers());

      if (ResHeaders.success) {
        const Headers = ResHeaders.operation;
        this.FIN_Table_Headers = Headers;

      } else {
        throw ResHeaders.message;
      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Headers)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    }
  }

  //-================== FUNCTTION FOR LOAD GROUPS NOTIFICATIONS ==================-\\
  private async Load_Groups(): Promise<void> {

    try {

      const ResGroupsNot: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Notification_Group());

      if (ResGroupsNot.success) {
        this.Group_Notification = ResGroupsNot.operation;
      }

      const ResAllGroups: any = await firstValueFrom(this.generalCDMSService.Get_All_Groups(this.FIN_LIB_SLUG));
      if (ResAllGroups?.success) {
        this.GroupsAvailable = ResAllGroups.operation || [];
      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error Grupos notificación',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

    }


  }

  //-================== FUNCTTION FOR LOAD TASKS ==================-\\
  private async Load_Task(): Promise<void> {

    try {

      const ResTask: any = await firstValueFrom(this.Service_FIN.Get_Task_Of_User({ ID_Involved_User: this.ID_User_BD, Status: 1, IsConsultViewTask: false }))

      if (ResTask.success) {

        const Tasks: TASK_ALL_FIN[] = ResTask.operation;

        this.All_Task_FIN = Tasks.length;

      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Obtener Tareas)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\



  //&===================== FUNCTIONS FOR NAVIGATION IN FOLDERS =====================&\\

  //-================== FUNCTTION FOR FOLDER NAVITATION ==================-\\
  public SeeFolder(FIN_Folder: FILE_FIN): void {
    this.NumberTopL += 1;

    const RouteLevel: string = FIN_Folder.Path;
    this.Route_Level_Global = RouteLevel;

    const ID_Folder: number = FIN_Folder.ID;

    const LastFolder: string = FIN_Folder.Path.split('/').pop() || '';

    if (!isNaN(ID_Folder)) {

      this.Header_Routes.push(LastFolder);

      this.CheckUserPermissionFolder(ID_Folder, RouteLevel);

    } else {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTTION FOR BACK NAVIGATION FOLDER ==================-\\
  public GoBackFolder(): void {

    this.NumberTopL -= 1;
    this.Header_Routes.pop();

    let CurrentRoute: string = this.Route_Level_Global;
    let RoutePop: string[] = CurrentRoute.split('/');
    RoutePop.pop();

    const RouteLevel: string = RoutePop.join('/');
    this.Route_Level_Global = RouteLevel;

    const LastFolder: string = RouteLevel.split('/').pop() || '';
    const ID_Folder: number = Number(LastFolder.split('§').shift());



    if (!isNaN(ID_Folder)) {

      this.CheckUserPermissionFolder(ID_Folder, RouteLevel);

    } else {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTTION FOR NAVIGATION FOR ROUTE ==================-\\
  public SeeFolder_BreadCrum(Position: number): void {


    const DifferenceNum: number = this.NumberTopL - Position;

    this.NumberTopL = Position;

    let CurrentRoute: string = this.Route_Level_Global;
    let RoutePop: string[] = CurrentRoute.split('/');

    for (let i = 0; i < DifferenceNum; i++) {
      RoutePop.pop();
      this.Header_Routes.pop();
    }

    const RouteLevel: string = RoutePop.join('/');
    this.Route_Level_Global = RouteLevel;

    const LastFolder: string = RouteLevel.split('/').pop() || '';
    const ID_Folder: number = Number(LastFolder.split('§').shift());

    if (!isNaN(ID_Folder)) {

      this.CheckUserPermissionFolder(ID_Folder, RouteLevel);

    } else {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTTION FOR CLEAN FILTER TABLE ==================-\\
  private cleanFilterTable(): void {
    this.FIN_Filter = '';
    if (this.dtFIN)
      this.dtFIN.filterGlobal(this.FIN_Filter, 'contains');
  }

  //-================== FUNCTTION FOR CHECK PERMISIONS IN FOLDER ==================-\\
  private async CheckUserPermissionFolder(ID_Folder: number, Route: string): Promise<void> {
    this.LoadPage = false;

    this.Permission_FMF = await this.PermissionFolder.GetPermissionsInFolderFIN(this.ID_User_BD, ID_Folder);

    console.log(this.Permission_FMF);

    this.ID_Folder_Level = ID_Folder;

    this.GetInformationDiretory(Route);

  }

  //&===================== END FUNCTIONS FOR NAVIGATION IN FOLDERS =====================&\\



  //&===================== FUNCTIONS FOR ADD NEW FOLDER FIN =====================&\\

  public ToggleModalAddFolderFIN(CloseOrOpen: boolean): void {
    if (CloseOrOpen) {
      this.FormAddFolderFIN.reset({
        NameFolderFIN: '',
        InheritanceGA: this.Route_Level_Global === '' ? false : true,
        Groups: [],
        OCR_Regex: '',
        OCR_Inheritance: this.Route_Level_Global === '' ? false : true
      });
      this.ShowAdvancedConfig = false;
    }

    const ModalAddFolderFIN = document.getElementById('ModalAddFolderFIN') as HTMLElement;
    if (ModalAddFolderFIN) {
      CloseOrOpen ? ModalAddFolderFIN.classList.add('active') : ModalAddFolderFIN.classList.remove('active');
    }
  }

  //-================== FUNCTTION FOR VALIDATIONS AND CREATE FOLDER FIN ==================-\\
  public AddFolder(): void {

    const NameFolder = String(this.FormAddFolderFIN.controls['NameFolderFIN'].value).trim();

    const IsExistinPath: boolean = this.Check_Folder_in_Path(NameFolder);

    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: `No puede nombrar la carpeta con este nombre `,
        text: `¡La carpeta ya existe en este directorio!`,
        confirmButtonColor: this.ColorConfirm
      })
    } else if (this.FormAddFolderFIN.valid) {
      Swal.fire({
        title: '¿El nombre de carpeta es correcto?',
        text: "Si todo esta bien, presiona el botón para continuar",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, Crear carpeta',
        cancelButtonText: 'No, Cancelar',
      }).then(async (result) => {

        if (result.isConfirmed) {

          try {
            Swal.fire({ title: 'Creando carpeta...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

            const reqBody = {
              Path: this.Route_Level_Global,
              Name: NameFolder,
              Inheritance: 1,
              InheritanceGA: this.FormAddFolderFIN.value.InheritanceGA ? 1 : 0,
              Optional_Approvers: 1,
              Groups: this.FormAddFolderFIN.value.Groups,
              OCR_Regex: this.FormAddFolderFIN.value.OCR_Inheritance ? null : (this.FormAddFolderFIN.value.OCR_Regex || '')
            };

            const ResCreatedFolder: Response_FIN = await firstValueFrom(this.Service_FIN.Create_Folder(reqBody));

            if (ResCreatedFolder.success) {
              Swal.fire({
                icon: 'success',
                title: 'Carpeta creada correctamente',
                confirmButtonColor: this.ColorConfirm,
                timer: 2000,
                showConfirmButton: false
              })
              this.SeeFolder_BreadCrum(this.NumberTopL);
              this.ToggleModalAddFolderFIN(false);
            }

          } catch (e) {
            Swal.fire({
              title: 'Ocurrió un error',
              text: '¡Ocurrió un error a crear una carpeta, si el problema persiste notifique a supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })
            this.SeeFolder_BreadCrum(this.NumberTopL);
            this.ToggleModalAddFolderFIN(false);
          }

        }



      })

    } else {
      Swal.fire({
        title: '¡Nombre no valido!',
        text: `No se permiten los siguientes caracteres \\ / : * ? " < > |`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //+================== GROUP ASSIGNMENT METHODS ==================+\\

  public get GroupsFiltered(): any[] {
    if (!this.SearchGroup || this.SearchGroup.length < 2) {
      return this.GroupsAvailable.slice(this.first_GA_Form, this.first_GA_Form + this.rows_GA_Form);
    }
    const lower = this.SearchGroup.toLowerCase();
    const filtered = this.GroupsAvailable.filter(g =>
      (g.Nombre || g.Name || '').toLowerCase().includes(lower) ||
      (g.Descripcion || g.Description || '').toLowerCase().includes(lower)
    );
    return filtered.slice(this.first_GA_Form, this.first_GA_Form + this.rows_GA_Form);
  }

  public get TotalGroupsForPaginator(): number {
    if (!this.SearchGroup || this.SearchGroup.length < 2) return this.GroupsAvailable.length;
    const lower = this.SearchGroup.toLowerCase();
    return this.GroupsAvailable.filter(g =>
      (g.Nombre || g.Name || '').toLowerCase().includes(lower) ||
      (g.Descripcion || g.Description || '').toLowerCase().includes(lower)
    ).length;
  }

  public get ReviewerHeaders(): Header_FIN[] {
    return this.FIN_Table_Headers.filter(h => h.Key_Header && h.Key_Header.startsWith('APPR') && h.Visible).sort((a, b) => a.Position - b.Position);
  }

  public AddReviewerRow() {
    let groups = [...(this.FormAddFolderFIN.value.Groups || [])];
    const nextLevel = groups.length + 1;
    groups.push({ ID_G: 0, ID_RG: nextLevel, Required_RG: true, GroupName: '' });
    this.FormAddFolderFIN.patchValue({ Groups: groups });
  }

  public RemoveReviewerRow(index: number) {
    let groups = [...(this.FormAddFolderFIN.value.Groups || [])];
    groups.splice(index, 1);

    // Re-indexar los niveles para que siempre sean secuenciales (Revisor 1, 2, 3...)
    groups = groups.map((g, i) => ({ ...g, ID_RG: i + 1 }));

    this.FormAddFolderFIN.patchValue({ Groups: groups });
  }

  public OpenModalSelectGroup(index: number): void {
    this.CurrentReviewerIndex = index;
    this.SearchGroup = '';
    this.first_GA_Form = 0;
    const Modal = document.getElementById('ModalSelectGroupReviewer');
    Modal?.classList.add('active');
    this.isOpenGroupModal = true;
  }

  public CloseModalSelectGroup(): void {
    const Modal = document.getElementById('ModalSelectGroupReviewer');
    Modal?.classList.remove('active');
    this.isOpenGroupModal = false;
  }

  public SelectGroupForReviewer(group: any): void {
    const groups = this.FormAddFolderFIN.value.Groups || [];
    if (this.CurrentReviewerIndex >= 0 && groups[this.CurrentReviewerIndex]) {
      const groupName = group.Nombre || group.Name || '';
      const groupId = group.ID_G || group.ID || 0;
      groups[this.CurrentReviewerIndex].ID_G = groupId;
      groups[this.CurrentReviewerIndex].GroupName = groupName;
      this.FormAddFolderFIN.patchValue({ Groups: [...groups] });
    }
    this.CloseModalSelectGroup();
    Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Grupo asignado', showConfirmButton: false, timer: 1500 });
  }

  public GetGroupName(index: number): string {
    const groups = this.FormAddFolderFIN.value.Groups || [];
    return groups[index]?.GroupName || 'Grupo aprobador no asignado';
  }

  public GetGroupInitials(index: number): string {
    const name = this.GetGroupName(index);
    if (name === 'Grupo aprobador no asignado') return '??';
    const parts = name.split(' ');
    return (parts[0][0] + (parts[1] ? parts[1][0] : parts[0][1] || '')).toUpperCase();
  }

  public onPageChangeGroupForm(event: any): void {
    this.first_GA_Form = event.first;
    this.rows_GA_Form = event.rows;
  }

  public Search_GroupForm(): void {
    // El getter GroupsFiltered ya maneja el filtrado reactivo
  }

  //-================== FUNCTTION FOR CHECK IF EXISIT FOLDER IN ROUTE ==================-\\
  private Check_Folder_in_Path(NameFolder: string): boolean {

    let Exist: boolean = false;

    this.All_FAF_FIN.map((item: FILE_FIN) => {
      if (item.Name === NameFolder) {
        Exist = true;
      }
    })

    return Exist;
  }

  //&===================== END FUNCTIONS FOR ADD NEW FOLDER FIN =====================&\\




  //&===================== FUNCTIONS FOR ADD NEW FIN =====================&\\

  public IsUploadFIN($event: any) {
    if ($event) {
      this.SeeFolder_BreadCrum(this.NumberTopL);
      if ($event.ID_WF && $event.useOCR) {
        this.Poll_Single_OCR_Status($event.ID_WF, $event.code, $event.name);
      }
    } else {
      Swal.fire({
        title: 'Error en el Proceso',
        text: '¡Ha ocurrido un error al cargar el Proceso, informe al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  public Open_Massive_Upload_FIN(): void {
    if (this.Enable_BtnNewFIN()) {
      Swal.fire({
        title: 'Operación no permitida',
        text: 'En la raíz solo se permite crear carpetas. Selecciona una carpeta para cargar procesos.',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return;
    }

    this.Sync_File_Type_Config_FIN();
    this.inputMassiveFIN?.nativeElement?.click();
  }

  private EscapeHtml(text: string): string {
    return `${text || ''}`
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  private BuildInvalidNameFilesHtml(files: string[]): string {
    const MaxItems = 20;
    const VisibleFiles = files.slice(0, MaxItems);
    const Omitted = files.length - VisibleFiles.length;

    const Items = VisibleFiles
      .map((fileName: string) => `<li>${this.EscapeHtml(fileName)}</li>`)
      .join('');

    const Extra = Omitted > 0 ? `<div style="margin-top:8px;">... y ${Omitted} archivo(s) más.</div>` : '';

    return `
      <div style="text-align:left;">
        <div>Use el formato <b>&lt;CODIGO&gt;_&lt;OBJETIVO&gt;.ext</b>.</div>
        <div style="margin-top:8px;">Archivos con formato inválido:</div>
        <ul style="margin:8px 0 0 18px; max-height:220px; overflow:auto;">${Items}</ul>
        ${Extra}
      </div>
    `;
  }

  private BuildInvalidExtensionFilesHtml(files: string[]): string {
    const MaxItems = 20;
    const VisibleFiles = files.slice(0, MaxItems);
    const Omitted = files.length - VisibleFiles.length;
    const SelectedTypeLabel = this.MainFileTypeOptionsFIN.find(item => item.Value === this.Get_Selected_Main_File_Type_FIN())?.Label || 'Word (.doc/.docx)';

    const Items = VisibleFiles
      .map((fileName: string) => `<li>${this.EscapeHtml(fileName)}</li>`)
      .join('');

    const Extra = Omitted > 0 ? `<div style="margin-top:8px;">... y ${Omitted} archivo(s) más.</div>` : '';

    return `
      <div style="text-align:left;">
        <div>Tipo de archivo permitido actualmente: <b>${this.EscapeHtml(SelectedTypeLabel)}</b>.</div>
        <div style="margin-top:8px;">Archivos con extensión inválida:</div>
        <ul style="margin:8px 0 0 18px; max-height:220px; overflow:auto;">${Items}</ul>
        ${Extra}
      </div>
    `;
  }

  private BuildDuplicateInCurrentDirFilesHtml(files: string[]): string {
    const MaxItems = 20;
    const VisibleFiles = files.slice(0, MaxItems);
    const Omitted = files.length - VisibleFiles.length;

    const Items = VisibleFiles
      .map((fileName: string) => `<li>${this.EscapeHtml(fileName)}</li>`)
      .join('');

    const Extra = Omitted > 0 ? `<div style="margin-top:8px;">... y ${Omitted} archivo(s) más.</div>` : '';

    return `
      <div style="text-align:left;">
        <div>Estos archivos no se pueden cargar porque ya existen en este directorio:</div>
        <ul style="margin:8px 0 0 18px; max-height:220px; overflow:auto;">${Items}</ul>
        ${Extra}
      </div>
    `;
  }

  public async On_Select_Files_Massive_FIN($event: Event): Promise<void> {
    this.Sync_File_Type_Config_FIN();

    const InputFile = $event.target as HTMLInputElement;
    const files: FileList | null = InputFile.files;

    if (!files || files.length === 0) {
      return;
    }

    if (this.ID_Folder_Level <= 0) {
      Swal.fire({
        title: 'Carpeta inválida',
        text: 'Primero selecciona una carpeta válida para cargar los procesos de forma múltiple.',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      InputFile.value = '';
      return;
    }

    const FilesArray: File[] = Array.from(files);

    const InvalidFiles: string[] = FilesArray
      .filter((file: File) => !this.Is_Valid_File(file.name))
      .map((file: File) => file.name);

    if (InvalidFiles.length > 0) {
      await Swal.fire({
        title: 'Archivos no válidos',
        html: this.BuildInvalidExtensionFilesHtml(InvalidFiles),
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      InputFile.value = '';
      return;
    }

    const InvalidNameFormatFiles: string[] = FilesArray
      .filter((file: File) => !this.Is_Valid_Massive_Name_Format_FIN(file.name))
      .map((file: File) => file.name);

    if (InvalidNameFormatFiles.length > 0) {
      await Swal.fire({
        title: 'Formato de nombre no válido',
        html: this.BuildInvalidNameFilesHtml(InvalidNameFormatFiles),
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      InputFile.value = '';
      return;
    }

    const ExistingNamesCurrentDir = new Set(
      this.All_FAF_FIN
        .filter((item: FILE_FIN) => !item.Directory)
        .map((item: FILE_FIN) => (item.Name || '').trim().toUpperCase())
    );

    const DuplicateInCurrentDir: string[] = FilesArray
      .filter((file: File) => ExistingNamesCurrentDir.has(file.name.trim().toUpperCase()))
      .map((file: File) => file.name);

    if (DuplicateInCurrentDir.length > 0) {
      await Swal.fire({
        title: 'Procesos repetidos',
        html: this.BuildDuplicateInCurrentDirFilesHtml(DuplicateInCurrentDir),
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      InputFile.value = '';
      return;
    }

    const BatchSet = new Set<string>();
    const DuplicateInBatch: string[] = [];
    FilesArray.forEach((file: File) => {
      const key = file.name.trim().toUpperCase();
      if (BatchSet.has(key)) {
        DuplicateInBatch.push(file.name);
      }
      BatchSet.add(key);
    });

    if (DuplicateInBatch.length > 0) {
      await Swal.fire({
        title: 'Archivos repetidos en selección',
        text: `Hay nombres repetidos en la carga múltiple: ${DuplicateInBatch.slice(0, 3).join(', ')}${DuplicateInBatch.length > 3 ? ' ...' : ''}`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      InputFile.value = '';
      return;
    }

    // Reset switches masivos
    this.UseOCR_LocalMassive = true;
    this.UseOCR_CloudMassive = false;


    const confirm = await Swal.fire({
      title: '¿Cargar archivos de forma múltiple?',
      html: `
        <div style="text-align:center; margin-bottom: 20px; font-size: 15px; color: #64748b;">
          Se cargarán <b>${FilesArray.length}</b> archivo(s) en la carpeta actual.
        </div>
        
        <div class="ocr-selection-card">
          <div class="ocr-row">
            <div class="ocr-info">
              <i class="fa-solid fa-server ocr-icon"></i>
              <span class="ocr-text">OCR Local</span>
            </div>
            <label class="sw-main">
              <input type="checkbox" id="sw-local-massive" ${this.UseOCR_LocalMassive ? 'checked' : ''}>
              <span class="sw-slider"></span>
            </label>
          </div>
          
          <div class="ocr-divider"></div>

          <div class="ocr-row">
            <div class="ocr-info">
              <i class="fa-solid fa-cloud ocr-icon"></i>
              <span class="ocr-text">OCR Cloud</span>
            </div>
            <label class="sw-main">
              <input type="checkbox" id="sw-cloud-massive" ${this.UseOCR_CloudMassive ? 'checked' : ''}>
              <span class="sw-slider"></span>
            </label>
          </div>
        </div>

        <style>
          .ocr-selection-card {
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            padding: 10px 5px;
            margin-top: 10px;
            box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
          }
          .ocr-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 15px;
          }
          .ocr-info {
            display: flex;
            align-items: center;
            gap: 12px;
          }
          .ocr-icon {
            font-size: 16px;
            color: #475569;
            width: 20px;
            text-align: center;
          }
          .ocr-text {
            font-size: 14px;
            font-weight: 600;
            color: #334155;
          }
          .ocr-divider {
            height: 1px;
            background: #f1f5f9;
            margin: 0 15px;
          }
          .sw-main { position: relative; display: inline-block; width: 42px; height: 22px; }
          .sw-main input { opacity: 0; width: 0; height: 0; }
          .sw-slider {
            position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0;
            background-color: #cbd5e1; transition: .4s; border-radius: 24px;
          }
          .sw-slider:before {
            position: absolute; content: ""; height: 16px; width: 16px; left: 3px; bottom: 3px;
            background-color: white; transition: .4s; border-radius: 50%;
          }
          input:checked + .sw-slider { background-color: #20a8e1; }
          input:checked + .sw-slider:before { transform: translateX(20px); }
        </style>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '<i class="fa-solid fa-upload"></i> Sí, cargar',
      cancelButtonText: 'No, cancelar',
      didOpen: () => {
        const swLocal = document.getElementById('sw-local-massive') as HTMLInputElement;
        const swCloud = document.getElementById('sw-cloud-massive') as HTMLInputElement;

        swLocal.addEventListener('change', () => {
          this.ToggleOCR_LocalMassive();
          swLocal.checked = this.UseOCR_LocalMassive;
          swCloud.checked = this.UseOCR_CloudMassive;
        });

        swCloud.addEventListener('change', () => {
          this.ToggleOCR_CloudMassive();
          swLocal.checked = this.UseOCR_LocalMassive;
          swCloud.checked = this.UseOCR_CloudMassive;
        });
      }
    });

    if (!confirm.isConfirmed) {
      InputFile.value = '';
      return;
    }

    const FormMassive = new FormData();
    FormMassive.append('ID_Folder', `${this.ID_Folder_Level}`);
    FormMassive.append('EnableFlow', 'false');
    FormMassive.append('UploadFileType', this.Get_Selected_Main_File_Type_FIN());

    const useOCR = this.UseOCR_LocalMassive || this.UseOCR_CloudMassive;
    const parserType = this.UseOCR_CloudMassive ? 'llama' : 'lite';

    FormMassive.append('UseLlamaIndex', useOCR.toString());
    FormMassive.append('parserType', parserType);

    FilesArray.forEach((file: File) => {
      FormMassive.append('FilesFINMassive', file, encodeURIComponent(file.name));
    });

    Swal.fire({
      title: 'Cargando...',
      text: 'Estamos cargando los procesos de forma múltiple.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.Service_FIN.Upload_Files_Massive(FormMassive).subscribe({
      next: async (event: any) => {
        if (event?.body) {
          const data = event.body.operation;
          const DuplicatesInSystem = data?.duplicatesInSystem || [];

          const baseMessage = `Procesados: ${data.totalFiles}. Cargados: ${data.uploadedCount}. Fallidos: ${data.failedCount}.`;
          const duplicateMessage = DuplicatesInSystem.length > 0
            ? ` Coincidencias en sistema: ${DuplicatesInSystem.length}.`
            : '';

          await Swal.fire({
            title: 'Carga completada',
            text: `${baseMessage}${duplicateMessage}`,
            icon: data.failedCount > 0 ? 'warning' : 'success',
            confirmButtonColor: this.ColorConfirm
          });

          this.SeeFolder_BreadCrum(this.NumberTopL);
          InputFile.value = '';

          if (data.uploaded && data.uploaded.length > 0) {
            if (this.UseOCR_LocalMassive || this.UseOCR_CloudMassive) {
              Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'info',
                title: 'Iniciando Procesamiento de Documentos',
                showConfirmButton: false,
                timer: 4500
              });

              if (data.uploaded && data.uploaded.length > 0) {
                this.Poll_OCR_Status(data.uploaded);
              }
            }
          }


        }
      },
      error: async () => {
        await Swal.fire({
          title: 'Error en carga múltiple',
          text: 'No se pudieron cargar los archivos de forma múltiple. Intente nuevamente o contacte al supervisor.',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        });
        InputFile.value = '';
      }
    });
  }



  public ToggleModalAddFIN(CloseOrOpen: boolean): void {
    if (CloseOrOpen && this.Enable_BtnNewFIN()) {
      Swal.fire({
        title: 'Operación no permitida',
        text: 'En la raíz solo se permite crear carpetas. Selecciona una carpeta para cargar procesos.',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return;
    }

    const ModalAddFIN = document.getElementById('ModalAddFIN') as HTMLDivElement;
    CloseOrOpen ? ModalAddFIN.classList.add('active') : ModalAddFIN.classList.remove('active');

    this.FormFIN.reset();
    this.FormFIN.controls['NameFIN'].setValue('');
    this.FileAuxAddFIN_Annexes = [];
    this.FileAuxAddFIN = {
      FileData: null,
      FileName: ''
    };
  }

  //-================== FUNCTTION FOR VALIDATA TYPE FILE ==================-\\
  public Is_Valid_File(Name_File: string): boolean {
    const SelectedType = this.Get_Selected_Main_File_Type_FIN();
    return this.Get_File_Name_Regex_FIN(SelectedType).test(Name_File);
  }

  private Is_Valid_Massive_Name_Format_FIN(fileName: string): boolean {
    const RawName = `${fileName || ''}`.trim();
    if (RawName === '') return false;

    const DotIndex = RawName.lastIndexOf('.');
    const BaseName = DotIndex > 0 ? RawName.slice(0, DotIndex).trim() : RawName;

    const separatorIndex = BaseName.indexOf('_');
    if (separatorIndex <= 0) return false;

    const code = BaseName.slice(0, separatorIndex).trim();
    const purpose = BaseName.slice(separatorIndex + 1).trim();

    return code !== '' && purpose !== '';
  }

  //-================== FUNCTTION FOR CUT NAME ==================-\\
  public CutNameFile(Name: string, length: number): string {

    if (Name !== undefined) {
      if (Name.length > length) {
        const Ext = Name.split('.').pop();
        const NameCut = Name.slice(0, length);
        return NameCut + '....' + Ext;
      } else {
        return Name;
      }

    } else {
      return '';
    }
  }

  //-================== FUNCTION FOR CHECK IF EXIST FIN IN PATH ==================-\\
  public Check_FIN_in_Path_Directory(NameFile: string, ID_FIN: number): boolean {

    let Exist: boolean = false;

    this.All_FAF_FIN.map((item: FILE_FIN) => {
      if (item.Name === NameFile && item.ID != ID_FIN) {
        Exist = true;
      }
    })

    return Exist;
  }

  //&===================== END FUNCTIONS FOR ADD NEW FIN =====================&\\



  //&===================== FUNCTIONS FOR SAME FILES =====================&\\

  //-================== FUNCTION TO KNOW OF EQUAL NAMES OF FIN ==================-\\
  public async Is_See_Files_Same_Name(NameFile: string, ModalNumber: number): Promise<void> {

    try {
      const ResFilesSame: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Equal_Name_FIN_InSF({ NameFile: NameFile }));

      if (ResFilesSame.success) {
        if (ResFilesSame.operation.length > 0) {
          this.FilesFIN_Dup = ResFilesSame.operation;
          this.Toggle_Modal_Same_Files_FIN(ModalNumber);
        }
      }

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al verificar si el Proceso ya existe en este directorio, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL SAME FILES ==================-\\
  public Toggle_Modal_Same_Files_FIN(ModalNumber: number): void {
    let ModalSameFHFIN = document.getElementById(`ModalSameFHFIN${ModalNumber}`) as HTMLDivElement;
    let ModalSameFilesFIN = document.getElementById(`ModalSameFilesFIN${ModalNumber}`) as HTMLDivElement;

    ModalSameFHFIN.classList.toggle('active');
    ModalSameFilesFIN.classList.toggle('active');
  }

  //&===================== END FUNCTIONS FOR SAME FILES =====================&\\



  //&===================== FUNCTIONS FOR UPDATE FIN =====================&\\

  public IsUpdateFIN($event: any) {

    if ($event) {
      this.SeeFolder_BreadCrum(this.NumberTopL);
    } else {
      Swal.fire({
        title: 'Error en el Proceso',
        text: '¡Ha ocurrido un error al cargar la actualización de el Proceso, informe al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  public Can_Upgrade(FIN: FILE_FIN, $event: any): void {

    if (FIN.Status === 1) {
      this.FFIN_Select_CM = FIN;
      this.ResetFormUpdate();
      this.FillFormUpdate();
      this.ToggleModalContext_Menu_Option_Upload(true, $event);

    }

    if (FIN.Status === 2) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: '¡Proceso en revisión!',
        text: 'Este Proceso esta en un proceso de aprobación. Puedes consultar la última versión aprobada.',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: 'Ver ultima revisión <i class="fa fa-arrow-right"></i>',
      }).then((result: any) => {
        if (result.isConfirmed) {
          window.open(`${URLs.URLINDEX}/Dashboard/FIN/LatestAppFIN/${FIN.ID}`)
          // this.router.navigate(['/Dashboard/FIN/LatestAppFIN/', FIN.ID]);
        }
      })
    }

    if (FIN.Status === 3) {
      this.FFIN_Select_CM = FIN;
      this.ResetFormUpdate();
      this.FillFormUpdate();
      this.ToggleModalUpdateFIN(true);
    }

  }

  //-================== FUNCTION RESET FORM AND FILEAUX ==================-\\
  public ResetFormUpdate() {
    this.FormFINUpdate.reset();
    this.FileAuxUpdFIN = {
      FileData: null,
      FileName: ''
    }
    this.FileAuxUpdFIN_Annexes = [];
  }

  //-================== FUNCTION FOR FILL FORM IN UPDATE FIN ==================-\\
  private async FillFormUpdate(): Promise<void> {

    await this.Load_Annexe(this.FFIN_Select_CM.ID, true);

    this.FormFINUpdate.controls['Code'].setValue(this.FFIN_Select_CM.Code);
    this.FormFINUpdate.controls['Purpose'].setValue(this.FFIN_Select_CM.Purpose);

    // Rellenar los revisores dinámicamente desde DynamicApprovers
    const dynamicApprovers = this.FFIN_Select_CM.DynamicApprovers || [];
    const formKeys = Object.keys(this.FormFINUpdate.controls).filter(k => k.startsWith('Approver'));
    for (const key of formKeys) {
      const UrIndex = parseInt(key.replace('Approver', ''), 10);
      const found = dynamicApprovers.find((a: any) => a.ID_UR === UrIndex);
      if (found) {
        this.FormFINUpdate.controls[key].setValue({ ID: found.ID_Involved_User, Name: found.Name });
      } else {
        this.FormFINUpdate.controls[key].setValue('');
      }
    }

    const Annexes_FIN: Annexe_ID[] = this.FFIN_Select_CM.Annexes;

    const Annexes_CAP: FILE_CAP_Annexe_ID[] = [];

    for (const Annexe of Annexes_FIN) {
      Annexes_CAP.push({ ID: Annexe.ID, FileData: '', FileName: Annexe.Name, Extension: Annexe.Extension, Status: 0, Consecutive: 0, UpdateAnnexe: { FileName: '', FileData: '', Extension: '' } });
    }

    this.FileAuxUpdFIN_Annexes = Annexes_CAP;

  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL UPDATE OF FIN ==================-\\
  public ToggleModalUpdateFIN(CloseOrOpen: boolean): void {
    const ModalUpdateFIN = document.getElementById('ModalUpdateFIN') as HTMLElement;
    CloseOrOpen ? ModalUpdateFIN.classList.add('active') : ModalUpdateFIN.classList.remove('active');
  }

  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL UPDATE ANNEXE ==================-\\
  public Toogle_Modal_Update_Annexe(CloseOrOpen: boolean): void {
    const Modal_Update_Annexe = document.getElementById('Modal_Update_Annexe') as HTMLElement;
    CloseOrOpen ? Modal_Update_Annexe.classList.add('active') : Modal_Update_Annexe.classList.remove('active');
  }

  //&===================== END FUNCTIONS FOR UPDATE FIN =====================&\\




  //&===================== FUNCTIONS FOR UPDATE ANNEXES FOR APPROVED FIN =====================&\\

  //-================== FUNCTION FOR TOGGLE MODAL FOR OPTIONS UPDATE ==================-\\
  public ToggleModalContext_Menu_Option_Upload(CloseOrOpen: boolean, $event: any): void {
    const Context_Menu_Option_Upload = document.getElementById('Context-Menu-Option-Upload') as HTMLElement;

    Context_Menu_Option_Upload.style.top = $event.clientY - 20 + "px";
    Context_Menu_Option_Upload.style.left = $event.clientX - 20 + "px";

    CloseOrOpen ? Context_Menu_Option_Upload.classList.add('active') : Context_Menu_Option_Upload.classList.remove('active');

  }

  //-================== FUNCTION FOR TOGGLE MODAL FOR UPDATE ANNEXE FOR APPROVED ==================-\\
  public ToggleModal_Update_Annexes_Approved(CloseOrOpen: boolean): void {
    const Modal_Update_Annexes_Approved = document.getElementById('Modal-Update-Annexes-Approved') as HTMLElement;
    CloseOrOpen ? Modal_Update_Annexes_Approved.classList.add('active') : Modal_Update_Annexes_Approved.classList.remove('active');
  }

  //-================== FUNCTION FOR DISABLED BUTTONS IN FIN FORM WHILE SENDING ==================-\\
  public OnDisabled_Update_Ann_App(IsDisabled: boolean): void {

    const Btn = document.getElementById('BtnSavedFIN-Update-Annexes-Approved') as HTMLButtonElement;
    const Btn_Close_Upd_Top = document.getElementById('Btn-Close-Update-Annexes-Approved-Top') as HTMLButtonElement;
    const Btn_Close_Upd_Bottom = document.getElementById('Btn-Close-Update-Annexes-Approved-Bot') as HTMLButtonElement;

    if (IsDisabled) {
      Btn.disabled = true;
      Btn_Close_Upd_Top.disabled = true;
      Btn_Close_Upd_Bottom.disabled = true;
    } else {
      Btn.disabled = false;
      Btn_Close_Upd_Top.disabled = false;
      Btn_Close_Upd_Bottom.disabled = false;
    }

  }

  //&===================== END FUNCTIONS FOR UPDATE ANNEXES FOR APPROVED FIN =====================&\\




  //&===================== FUNCTIONS FOR CONTEXT-MENU-CLICK =====================&\\

  public IsChangeEventFIN(event: any) {
    if (event) {
      this.GetInformationDiretory(this.Route_Level_Global);
    }
  }

  private contextMenuOutsideHandler = (e: MouseEvent) => {
    const menu = document.getElementById('Context-Menu');
    if (menu && !menu.contains(e.target as Node)) {
      menu.classList.remove('active');
      document.removeEventListener('click', this.contextMenuOutsideHandler, true);
      window.removeEventListener('scroll', this.scrollHandler, true);
    }
  };

  private scrollHandler = () => {
    const menu = document.getElementById('Context-Menu');
    if (menu) {
      menu.classList.remove('active');
    }
    window.removeEventListener('scroll', this.scrollHandler, true);
    document.removeEventListener('click', this.contextMenuOutsideHandler, true);
  };

  //-================== FUNCTION FOR OPEN CONTEXT MENU ==================-\\
  public RightClick_Context_Menu($event: any, FIN: FILE_FIN, fromMobileButton: boolean = false): void {
    if (this.isMobileDevice && !fromMobileButton) {
      $event.preventDefault?.();
      return;
    }

    if ($event.preventDefault) $event.preventDefault();
    if ($event.stopPropagation) $event.stopPropagation();

    let clientX = 0;
    let clientY = 0;

    if ($event instanceof MouseEvent) {
      clientX = $event.clientX;
      clientY = $event.clientY;
    } else if ($event.touches && $event.touches.length > 0) {
      clientX = $event.touches[0].clientX;
      clientY = $event.touches[0].clientY;
    } else if ($event.changedTouches && $event.changedTouches.length > 0) {
      clientX = $event.changedTouches[0].clientX;
      clientY = $event.changedTouches[0].clientY;
    }

    const shouldOpenMenu = fromMobileButton || ($event instanceof MouseEvent ? $event.which === 3 : true);
    const pop: any = document.getElementById('Context-Menu');
    if (pop && shouldOpenMenu) {
      // Usar el botón como referencia en móvil para mayor estabilidad
      if (fromMobileButton && $event.currentTarget) {
        const rect = $event.currentTarget.getBoundingClientRect();
        clientX = rect.left;
        clientY = rect.top + rect.height / 2;
      }

      // Medir altura real si el menú ya es visible o usar un valor más real
      pop.classList.add('active'); // Lo activamos brevemente para medirlo
      const actualHeight = pop.offsetHeight || 200;
      const actualWidth = pop.offsetWidth || 220;

      let top = clientY;
      let left = clientX;

      if (clientY + actualHeight > window.innerHeight) {
        top = clientY - actualHeight;
      }

      if (clientX + actualWidth > window.innerWidth) {
        left = clientX - actualWidth;
      }

      pop.style.top = `${top}px`;
      pop.style.left = `${left}px`;

      // Limpiar listeners previos antes de agregar nuevos
      document.removeEventListener('click', this.contextMenuOutsideHandler, true);
      window.removeEventListener('scroll', this.scrollHandler, true);

      // Registrar listeners con pequeño delay para que el click actual no los dispare
      setTimeout(() => {
        document.addEventListener('click', this.contextMenuOutsideHandler, true);
        window.addEventListener('scroll', this.scrollHandler, true);
      }, 0);
    }

    this.FFIN_Select_CM = FIN;
    console.log(this.FFIN_Select_CM);
  }

  get isMobileDevice(): boolean {
    return window.innerWidth <= 1024 || ('ontouchstart' in window);
  }

  // --- MÉTODOS TOUCH DND ---

  public OnTouchStart(event: TouchEvent, item: any): void {
    if (!this.isMobileDevice) return;

    const isItemSelected = this.SelectedALL_FAF_FIN?.some((s: any) => s.ID === item.ID);
    if (!isItemSelected) {
      this.SelectedALL_FAF_FIN = [item as any];
    }
    
    // Capturar el parentPath para validaciones de redundancia
    this.touchDraggedItems = this.SelectedALL_FAF_FIN.map((s: any) => ({
      ...s,
      parentPath: this.Route_Level_Global
    }));

    const touch = event.touches[0];
    this.touchX = touch.clientX;
    this.touchY = touch.clientY;

    this.touchTimer = setTimeout(() => {
      this.isTouchDragging = true;
      if (navigator.vibrate) navigator.vibrate(50);
    }, 600);
  }

  public OnTouchMove(event: TouchEvent): void {
    if (!this.touchDraggedItems || this.touchDraggedItems.length === 0) return;
    const touch = event.touches[0];

    if (!this.isTouchDragging) {
      const dist = Math.sqrt(Math.pow(touch.clientX - this.touchX, 2) + Math.pow(touch.clientY - this.touchY, 2));
      if (dist > 10) clearTimeout(this.touchTimer);
      return;
    }

    this.touchX = touch.clientX;
    this.touchY = touch.clientY;

    // Auto-scroll si se arrastra cerca de los bordes
    this.HandleAutoScroll(this.touchY, this.touchX);

    // Detectar destino para feedback visual
    const elementAtPoint = document.elementFromPoint(this.touchX, this.touchY);
    this.UpdateTouchFeedback(elementAtPoint);

    if (event.cancelable) event.preventDefault();
  }

  private UpdateTouchFeedback(element: Element | null): void {
    this.dragOverFolderId = null;
    this.dragOverBreadcrumbIndex = -1;

    if (!element) return;

    // 1. Breadcrumb
    const breadcrumb = element.closest('.Route-Generator');
    if (breadcrumb) {
      const indexAttr = breadcrumb.getAttribute('data-index');
      if (indexAttr !== null) {
        const index = Number(indexAttr);

        // --- VALIDACIÓN RAIZ PARA TOUCH ---
        const containsFile = this.touchDraggedItems.some((i: any) => !i.Directory);
        if (index === 0 && containsFile) {
          return;
        }

        this.dragOverBreadcrumbIndex = index;
        return;
      }
    }

    // 2. Carpeta en tabla
    const row = element.closest('tr[data-id]');
    if (row) {
      const folderId = Number(row.getAttribute('data-id'));
      const folder = this.All_FAF_FIN.find(i => i.ID === folderId && i.Directory);
      if (folder) {
        this.dragOverFolderId = folder.ID;
      }
    }
  }

  public OnTouchEnd(event: TouchEvent): void {
    clearTimeout(this.touchTimer);

    // Limpiar feedback visual
    this.dragOverFolderId = null;
    this.dragOverBreadcrumbIndex = -1;
    this.isScrolling = false;
    this.scrollDirection = 0;
    this.scrollSpeed = 0;

    if (!this.isTouchDragging) {
      this.touchDraggedItems = [];
      // Detener auto-scroll
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
      return;
    }

    const touch = event.changedTouches[0];
    const elementAtPoint = document.elementFromPoint(touch.clientX, touch.clientY);
    this.HandleTouchDrop(elementAtPoint);

    this.isTouchDragging = false;
    this.touchDraggedItems = [];

    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }

  private async HandleTouchDrop(element: Element | null): Promise<void> {
    if (!element || !this.touchDraggedItems || this.touchDraggedItems.length === 0) return;

    // 1. Breadcrumb
    const breadcrumb = element.closest('.Route-Generator');
    if (breadcrumb) {
      const indexAttr = breadcrumb.getAttribute('data-index');
      if (indexAttr !== null) {
        const index = Number(indexAttr);

        // --- VALIDACIÓN RAIZ PARA TOUCH ---
        const containsFile = this.touchDraggedItems.some((i: any) => !i.Directory);
        if (index === 0 && containsFile) {
          Swal.fire({
            icon: 'warning',
            title: 'Movimiento no permitido',
            text: 'En la raíz solo se permiten carpetas.',
            confirmButtonColor: '#20a8e1'
          });
          return;
        }

        const destinationPath = this.GetBreadcrumbDropPath(index);
        const targetFolderStr = this.Header_Routes[index];
        const success = await this.MoveItemsToDestination(this.touchDraggedItems, targetFolderStr, destinationPath);
        if (success) {
          setTimeout(() => this.SeeFolder_BreadCrum(index), 500);
          this.SelectedALL_FAF_FIN = [];
          this.IsMultiSelectMode = false;
        }
        return;
      }
    }

    // 2. Carpeta en tabla
    const row = element.closest('tr[data-id]');
    if (row) {
      const folderId = Number(row.getAttribute('data-id'));
      const folder = this.All_FAF_FIN.find(i => i.ID === folderId && i.Directory);
      if (folder) {
        const success = await this.MoveItemsToDestination(this.touchDraggedItems, `${folder.ID}§${folder.Name}`, folder.Path || '');
        if (success) {
          setTimeout(() => this.OnFolderClick(null as any, folder), 500);
          this.SelectedALL_FAF_FIN = [];
          this.IsMultiSelectMode = false;
        }
      }
    }
  }

  private isScrolling = false;
  private scrollDirection = 0;
  private scrollSpeed = 0;
  private lastTouchX = 0;
  private lastTouchY = 0;

  private HandleAutoScroll(clientY: number, clientX: number): void {
    const table = document.querySelector('.p-datatable-table-container') ||
      document.querySelector('.p-datatable-wrapper') ||
      document.querySelector('.p-datatable-viewport');

    if (!table) return;

    const rect = table.getBoundingClientRect();
    const threshold = rect.height * 0.15; // 15% de la altura de la tabla como zona caliente

    this.lastTouchX = clientX;
    this.lastTouchY = clientY;

    // Verificar si estamos dentro del ancho de la tabla
    if (clientX < rect.left || clientX > rect.right) {
      this.isScrolling = false;
      this.scrollDirection = 0;
      return;
    }

    // Detectar scroll relativo a los bordes de la TABLA, no de la pantalla
    if (clientY >= rect.top && clientY < rect.top + threshold) {
      this.scrollDirection = -1; // Subir tabla
      this.scrollSpeed = Math.max(10, 50 * (1 - ((clientY - rect.top) / threshold)));
    } else if (clientY <= rect.bottom && clientY > rect.bottom - threshold) {
      this.scrollDirection = 1; // Bajar tabla
      this.scrollSpeed = Math.max(10, 50 * (1 - ((rect.bottom - clientY) / threshold)));
    } else {
      this.scrollDirection = 0;
      this.isScrolling = false;
      return;
    }

    if (!this.isScrolling) {
      this.StartScrollLoop(table);
    }
  }

  private StartScrollLoop(table: Element): void {
    if (this.isScrolling) return;
    this.isScrolling = true;

    const scrollStep = () => {
      if (!this.isScrolling || this.scrollDirection === 0) {
        this.isScrolling = false;
        return;
      }

      // Desplazamiento exclusivo de la tabla
      table.scrollTop += this.scrollDirection * this.scrollSpeed;

      requestAnimationFrame(scrollStep);
    };

    requestAnimationFrame(scrollStep);
  }

  //&===================== END FUNCTIONS FOR CONTEXT-MENU-CLICK =====================&\\




  //&===================== FUNCTIONS FOR GENERAL SYSTEM =====================&\\

  //-================== FUNCTION FOR GET FILES AND FOLDERS IN ROUTE ==================-\\
  private ResolveFINIdentifier(item: any): number {
    const candidateKeys = ['ID', 'Id', 'ID_FIN', 'ID_WF', 'ID_Process'];

    if (item?.Directory === true) {
      candidateKeys.push('ID_Folder');
    }

    for (const key of candidateKeys) {
      const value = Number(item?.[key]);
      if (!Number.isNaN(value) && value > 0) {
        return value;
      }
    }

    return 0;
  }

  private NormalizeFINDirectoryItems(items: any[]): FILE_FIN[] {
    return (items || []).map((item: any) => ({
      ...item,
      ID: this.ResolveFINIdentifier(item),
    })) as FILE_FIN[];
  }

  private async GetInformationDiretory(Route: string): Promise<void> {
    this.SelectedALL_FAF_FIN = [];
    this.IsMultiSelectMode = false;

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader?.classList.add('active');

    this.Load_Task();

    const ResFINDir: Response_FIN = await firstValueFrom(this.Service_FIN.Get_FIN_Of_Directory({ path: Route }));

    if (ResFINDir.success) {
      this.LoadPage = true;

      this.All_FAF_FIN = this.NormalizeFINDirectoryItems(ResFINDir.operation.items);
      this.TotalFilesFIN = ResFINDir.operation.Total_Files;
      this.TotalFoldersF = ResFINDir.operation.Total_Folders;
      this.cleanFilterTable();

      Loader?.classList.remove('active');

      this.Generate_Filters();
      this.TryOpenDocumentPropertiesFromSearch();

    } else {
      Loader?.classList.remove('active');
      this.LoadPage = true;
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  private TryOpenDocumentPropertiesFromSearch(): void {
    const shouldOpen = String(this.ActivatedRouter.snapshot.queryParamMap.get('openProperties') || '') === '1';

    if (!shouldOpen || !Array.isArray(this.All_FAF_FIN) || this.All_FAF_FIN.length === 0) {
      return;
    }

    const documentId = Number(this.ActivatedRouter.snapshot.queryParamMap.get('documentId') || 0);
    const documentName = String(this.ActivatedRouter.snapshot.queryParamMap.get('documentName') || '').trim().toLowerCase();
    const documentExtension = String(this.ActivatedRouter.snapshot.queryParamMap.get('documentExtension') || '').trim().toLowerCase();
    const normalizedDocumentName = documentName && documentExtension && !documentName.endsWith(`.${documentExtension}`)
      ? `${documentName}.${documentExtension}`
      : documentName;

    const targetDocument = this.All_FAF_FIN.find((item: FILE_FIN) => {
      if (!item || item.Directory) {
        return false;
      }

      if (documentId > 0 && Number(item.ID) === documentId) {
        return true;
      }

      const itemName = String(item.Name || '').trim().toLowerCase();
      if (normalizedDocumentName && itemName === normalizedDocumentName) {
        return true;
      }

      if (documentName && itemName === documentName) {
        return true;
      }

      return false;
    });

    if (!targetDocument) {
      return;
    }

    this.FFIN_Select_CM = targetDocument;

    const openModal = (): void => {
      if (!this.contextMenuPrcFIN || typeof this.contextMenuPrcFIN.ToggleModalProperties !== 'function') {
        return;
      }

      this.contextMenuPrcFIN.FFIN_Select_CM = targetDocument;
      this.contextMenuPrcFIN.ToggleModalProperties(true);
      this.ClearSearchPropertiesQueryParams();
    };

    if (this.contextMenuPrcFIN) {
      openModal();
      return;
    }

    setTimeout(() => openModal(), 0);
  }

  private ClearSearchPropertiesQueryParams(): void {
    const currentUrl = this.Router.url.split('?')[0];
    window.history.replaceState(window.history.state, '', currentUrl);
  }

  //-================== FUNCTION FOR FILTERS ==================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Status: [],
      Revision_No: [],
      Approver1_Name: [],
      Approver2_Name: [],
      Approver3_Name: [],
      Approver4_Name: [],
      Contributor_Name: [],
    };

    for (const FIN of this.All_FAF_FIN as any) {

      FIN.Date_Created = moment(FIN.Date_Created).utc().toDate();
      FIN.Date_Expiration = moment(FIN.Date_Expiration).utc().toDate();

      FIN.F_Extension = { Value: FIN.Extension } as Data_Check;
      FIN.F_Status = { Value: FIN.Status } as Data_Check;
      FIN.F_Revision_No = { Value: FIN.Revision_No } as Data_Check;
      FIN.F_Contributor_Name = { Value: FIN.Contributor_Name } as Data_Check;

      if (!this.Filter_Global_Check.Extension.some((item: any) => item.Value === FIN.Extension) && FIN.Extension !== null) {
        this.Filter_Global_Check.Extension.push({ Value: FIN.Extension })
      }

      if (!this.Filter_Global_Check.Status.some((item: any) => item.Value === FIN.Status) && FIN.Status !== null) {
        this.Filter_Global_Check.Status.push({ Value: FIN.Status })
      }

      if (!this.Filter_Global_Check.Revision_No.some((item: any) => item.Value === FIN.Revision_No) && FIN.Revision_No !== null) {
        this.Filter_Global_Check.Revision_No.push({ Value: FIN.Revision_No })
      }

      if (!this.Filter_Global_Check.Contributor_Name.some((item: any) => item.Value === FIN.Contributor_Name) && FIN.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push({ Value: FIN.Contributor_Name })
      }

    }


  }

  //-================== FUNCTION FOR ENABLE BTN NEW FIN ==================-\\
  public Enable_BtnNewFIN(): boolean {
    return this.Route_Level_Global.trim() === '' || this.ID_Folder_Level <= 0;
  }

  //-================== FUNCTION FOR ENABLE INPUT SEARCH FIN ==================-\\
  public Show_InputSearch(): boolean {

    if (this.Header_Routes.length > 3) {
      return true;
    }

    for (const FIN of this.All_FAF_FIN) {
      if (!FIN.Directory) {
        return true;
      }
    }
    return false;
  }

  // ============== FUNCTION FOR VERIFY IS NEW FIN ==============\\
  public Is_New_FIN_In_System(Date_Update: Date | null): boolean {

    const Current_Date = moment().utc();
    const Date_add = moment(Date_Update).utc().add(7, 'day');

    return (Date_add > Current_Date);

  }

  public Cut_Purpose(Purpose: string): string {
    return Purpose.length > 32 ? Purpose.slice(0, 32) + '...' : Purpose;
  }

  public See_Purpose(Purpose: string): void {
    Swal.fire({
      title: 'Objetivo del proceso',
      text: Purpose,
      confirmButtonColor: this.ColorConfirm
    })
  }

  public Cut_Code(Code: string): string {
    return Code.length > 15 ? Code.slice(0, 15) + '...' : Code;
  }

  public See_Code(Code: string): void {
    Swal.fire({
      title: 'Código',
      text: Code,
      confirmButtonColor: this.ColorConfirm
    })
  }

  // ============== FUNCTION FOR VERIFY IF CONTAINS ANNEXE ==============\\
  public Can_See_Modal_Annexe(FIN: FILE_FIN): void {
    this.FFIN_Select_CM = FIN;
    this.Load_Annexe(FIN.ID, false);
    this.Modal_See_Annexe(true);
  }

  public async Load_Annexe(ID: number, IsFill_Form: boolean): Promise<boolean> {

    try {
      this.annexesErrorFM = [];
      const ResAnnexe: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Annexe_Of_FIN({ ID_WF: ID, IsFill_Form: IsFill_Form }));

      if (ResAnnexe.success) {
        this.FFIN_Select_CM.Annexes = ResAnnexe.operation.Annexes;
        this.annexesErrorFM = ResAnnexe.operation.AnnexesErrorFS;
      } else {
        throw "ERROR"
      }

      return true;
    } catch (e) {


      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Ocurrió un error al cargar los anexos del proceso, si el problema persiste informa a tu supervisor!'
      })

      return false;
    }

  }

  // ============== FUNCTION FOR OPEN OR CLOSE MODAL, FOR SEE ANNEXE ==============\\
  public Modal_See_Annexe(CloseOrOpen: boolean): void {
    const Modal_See_Annexe = document.getElementById('Modal-See-Annexe') as HTMLDivElement;
    CloseOrOpen ? Modal_See_Annexe.classList.add('active') : Modal_See_Annexe.classList.remove('active');
  }

  public verifyAnnexeInFS(Annexe: Annexe): boolean {
    return this.annexesErrorFM.some((item: Annexe) => item.ID === Annexe.ID)
  }

  public alertNotAnnexeInFS(): void {
    Swal.fire({
      title: 'Anexo no disponible',
      text: 'El anexo no está disponible para descarga. No se encuentra en el sistema de archivos. Por favor, notifíquelo a su supervisor.',
      icon: 'warning',
      confirmButtonColor: this.ColorConfirm,
    })
  }

  // ============== VALIDATION FUNCTION TO DOWNLOAD ANNEX ==============\\
  public Can_Download_Annexe(Annexe: Annexe): void {

    const IsAdmin = this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorFIN])

    if (IsAdmin) {
      this.Get_Download_Annexe(Annexe);
    } else {
      switch (Number(this.ID_User_BD)) {
        case Number(this.FFIN_Select_CM.ID_Contributor): this.Get_Download_Annexe(Annexe); break;
        default:
          // Verificación dinámica: el usuario es revisor si está en DynamicApprovers
          const isAnyApproverAnnex = (this.FFIN_Select_CM.DynamicApprovers || []).some((a: any) => a.ID_Involved_User === Number(this.ID_User_BD));
          if (isAnyApproverAnnex) {
            this.Get_Download_Annexe(Annexe);
          } else {
            this.Message_NP_Download_Annexe(Annexe);
          }
      }

    }
  }

  public See_Version_History_Annexe(Annexe: Annexe): void {
    const IsAdmin = this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorFIN]);
    if (!IsAdmin && !this.UserRoleIn([this.PermissionFIN.versionHistoryAnnexe])) {
      Swal.fire('Acción no permitida', 'No tienes permisos para ver el historial de anexos.', 'warning');
      return;
    }

    window.open(`${URLs.URLINDEX}/Dashboard/FIN/HistAnn/${Annexe.ID}/${this.ID_Folder_Level}`)
  }

  // ============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============\\
  private async Get_Download_Annexe(Annexe: Annexe): Promise<void> {

    try {

      const ResGetURLFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_Annexe_FIN({ ID_Annexe: Annexe.ID, Type_D: Download_Log_FIN.D_ANNEXE_FILE_M }));

      if (ResGetURLFIN.success) {

        const URL = ResGetURLFIN.operation.URL_Annexe;

        const IsDownload = this.Download_Annexe_FIN(URL, Annexe.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el anexo del Proceso, informa a tu supervisor!'
      })
    }

  }

  // ============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============\\
  private async Download_Annexe_FIN(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const Container_Download_Annexe = document.getElementById('Container-Download-Annexe') as HTMLDivElement;
      const Progress_Bar_Annexe = document.getElementById('Progress-Bar-Annexe') as HTMLDivElement;

      Container_Download_Annexe.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Annexe.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          Container_Download_Annexe.classList.remove('active');
          Progress_Bar_Annexe.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Anexo descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el anexo del Proceso, informe a su supervisor!'
          })

          Container_Download_Annexe.classList.remove('active');
          Progress_Bar_Annexe.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  // ============== FUNCTION TO SHOW MESSAGE FOR NOT HAVING PERMISSION TO DOWNLOAD ANNEX ==============\\
  private Message_NP_Download_Annexe(Annexe: Annexe): void {

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    Toast.fire({
      icon: 'warning',
      title: '¡No tiene permisos para descargar este anexo!'
    })
  }

  public Get_Name_Approver(Name: string | null | undefined) {
    return Name === null ? 'No fue requerido' : Name;
  }

  // ============== FUNCTION FOR FORMAT DATE CREATED ==============\\
  public Get_Date_Created(Date_Created: Date | null): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  // ============== FUNCTION FOR FORMAT DATE CREATED ==============\\
  public Get_Date_Modification(Modification: Date | null): string {
    return moment(Modification).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  // ============== FUNCTION FOR FORMAT DATE EXPIRATION ==============\\
  public Get_Date_Expiration(Expiration: Date | null): string {
    return moment(Expiration).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  // ============== FUNCTION FOR FORMAT STATUS ==============\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobado';
      case 2: return 'Pendiente';
      case 3: return 'Rechazado';
      case 4: return 'Eliminado';
      default: return '';
    }
  }

  // ============== FUNCTION FOR CLASS EXPIRATION STATUS ==============\\
  public Expiry_Status(Date_Expiration: Date): string {

    const Current_Date = moment().utc();

    const Date_Difference = moment(Date_Expiration, 'YYYY/MM/DD').utc();

    const Diference = Date_Difference.diff(Current_Date, 'days');

    if (Diference >= 90) {
      return 'NotExpired'
    } else if (Diference >= 0 && Diference <= 90) {
      return 'NearingExpired'
    } else if (Diference < 0) {
      return 'Expired'
    } else {
      return 'NotExpired'
    }
  }

  // ============== HELPER: VERIFICA SI EL USUARIO PUEDE DESCARGAR ==============\\
  // Admin, permiso de carpeta, contribuidor o aprobador del documento
  public CanDownload(FIN: FILE_FIN): boolean {
    const IsAdmin = this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorFIN, this.RolesGeneral.SuperAdministrator]);
    const HasFolderDownloadPermission = this.UserRoleIn([this.PermissionFIN.downloadVersionFlow]);
    const IsContributor = Number(this.ID_User_BD) === Number(FIN.ID_Contributor);
    const IsApprover = (FIN.DynamicApprovers || []).some((a: any) => a.ID_Involved_User === Number(this.ID_User_BD));
    return IsAdmin || HasFolderDownloadPermission || IsContributor || IsApprover;
  }

  // ============== FUNCTION FOR DOWNLOAD FILE IN TABLE ==============\\
  public DownloadTable(FIN: FILE_FIN): void {

    const IsAdmin = this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorFIN, this.RolesGeneral.SuperAdministrator]);
    const IsApprover = (FIN.DynamicApprovers || []).some((a: any) => a.ID_Involved_User === Number(this.ID_User_BD));
    const IsDirectMultipleLoad = this.Is_Direct_Multiple_Load(FIN);
    const IsPrintableProcess = this.Is_Printable_Process(FIN);

    if (FIN.Status === 1 && IsPrintableProcess && !IsDirectMultipleLoad) {
      this.Download_Print_Format(FIN);
    } else if (IsAdmin) {
      this.DownloadFileFIN(FIN);
    } else {
      switch (Number(this.ID_User_BD)) {
        case Number(FIN.ID_Contributor): this.DownloadFileFIN(FIN); break;
        default:
          if (IsApprover) {
            this.DownloadFileFIN(FIN);
          } else {
            this.Download_Last_Version(FIN);
          }
      }
    }

  }

  public async PreviewFile(item: any, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (item.Directory || !this.CanDownload(item)) return;

    // Guardamos el item seleccionado para que el botón de descarga del visor sepa qué descargar
    this.FFIN_Select_CM = item;

    Swal.fire({
      title: 'Cargando vista previa...',
      didOpen: () => { Swal.showLoading(); },
      allowOutsideClick: false
    });

    try {
      const res: Response_FIN = await firstValueFrom(this.masterService.Get_URL_Download(this.FIN_LIB_SLUG, { ID_WF: item.ID, isPreview: true }));

      // Cerramos el loading de Swal ANTES de activar el visor
      Swal.close();

      if (!res.success) {
        throw new Error('No se pudo resolver la URL del documento.');
      }

      this.previewFileUrl = String(res.operation?.URL_Document || '').trim();
      this.previewFileName = item.Name;
      this.previewFileExtension = item.Extension;
      this.showPreview = true;
    } catch (e) {
      Swal.close();
      console.error(e);
      Swal.fire('Error', 'No se pudo cargar la vista previa', 'error');
    }
  }

  public DownloadFromPreview() {
    if (this.FFIN_Select_CM) {
      this.DownloadTable(this.FFIN_Select_CM);
    }
  }

  private Is_Direct_Multiple_Load(FIN: FILE_FIN): boolean {
    const Purpose = (FIN.Purpose || '').toUpperCase();
    return Purpose === 'DIRECT MULTIPLE LOAD' || Purpose === 'DIRECT MASSIVE LOAD';
  }

  private Is_Printable_Process(FIN: FILE_FIN): boolean {
    const NameLower = (FIN.Name || '').toLowerCase();
    return NameLower.endsWith('.doc') || NameLower.endsWith('.docx');
  }

  private GetValidFINId(fin: FILE_FIN, context: string): number | null {
    const id = this.ResolveFINIdentifier(fin as any);

    if (id > 0) {
      return id;
    }

    console.error(`[FIN] ${context}: proceso sin ID valido`, fin);
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });

    Toast.fire({
      icon: 'error',
      title: 'No se pudo identificar el proceso para descarga.'
    });

    return null;
  }

  // ============== FUNCTION FOR DOWNLOAD FILE FIN ==============\\
  private async DownloadFileFIN(FIN: FILE_FIN): Promise<void> {

    try {

      const finId = this.GetValidFINId(FIN, 'DownloadFileFIN');
      if (!finId) return;

      const ResGetURLFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_FIN({ ID_FIN: finId, Type_D: Download_Log_FIN.D_FILE_MANAGERC }));

      if (ResGetURLFIN.success) {

        const URL = ResGetURLFIN.operation.URL_FIN;

        const IsDownload = this.Download_File_FIN(URL, FIN.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el Proceso, informa a tu supervisor!'
      })
    }

  }

  // ============== FUNCTION FOR DOWNLOAD PRINT FORMAT ==============\\
  private async Download_Print_Format(FIN: FILE_FIN): Promise<void> {


    const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
    ProgressModal.classList.add('active');

    try {

      const finId = this.GetValidFINId(FIN, 'Download_Print_Format');
      if (!finId) {
        ProgressModal.classList.remove('active');
        return;
      }

      const ResPrintFormat: Response_FIN = await firstValueFrom(this.Service_FIN.Generate_Print_Format_FIN({ ID_FIN: finId, Type_D: Download_Log_FIN.D_PRINT_FORMATF }));

      const URL = ResPrintFormat.operation.URL_FIN_PF;


      let Name_Split: string[] = FIN.Name.split('.'); Name_Split.pop();

      const Name_Download: string = `${Name_Split.join('.')}.${URL.split('.').pop()}`

      if (ResPrintFormat.success) {

        const IsDownload = this.Download_File_FIN(URL, Name_Download);

        if (!IsDownload) throw new Error('No file Download');

      } else {
        throw "ERROR";
      }


    } catch (error) {
      console.warn('[FIN] Error al generar Formato de Impresión, reintentando descarga de archivo original', error);

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'warning',
        title: 'Error en conversión a PDF. Descargando archivo original...'
      })

      ProgressModal.classList.remove('active');
      this.DownloadFileFIN(FIN);
    }

  }

  // ============== FUNCTION FOR DOWNLOAD FILE LAS VERSION  ==============\\
  private async Download_Last_Version(FIN: FILE_FIN): Promise<void> {

    let StatusText: string = '';

    if (FIN.Status === 2) {
      StatusText = 'Pendiente'
    } else if (FIN.Status === 3) {
      StatusText = 'Rechazado'
    }

    Swal.fire({
      title: `Proceso ${StatusText}`,
      text: `Este Proceso tiene esta revisión ${StatusText}. Puedes descargar la última versión aprobada.`,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      showCancelButton: true,
      confirmButtonText: 'Descargar última revisión aprobada <i class="fa-solid fa-cloud-arrow-down"></i>',
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {

          const finId = this.GetValidFINId(FIN, 'Download_Last_Version');
          if (!finId) return;

          const ResGetLastVersion: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Last_Version_Approved({ ID_FIN: finId }));

          if (ResGetLastVersion.success) {

            const ResLastVersion: Response_FIN = ResGetLastVersion;

            if (ResLastVersion.operation.Exist_VA) {

              const FIN_LAST_VA: Data_VH_FIN = ResLastVersion.operation.FIN;

              const ResGetURLFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Generate_Print_Format_FIN({ ID_FIN: FIN_LAST_VA.ID, Type_D: Download_Log_FIN.D_PRINT_FORMATF }));

              if (ResGetURLFIN.success) {

                const URL = ResGetURLFIN.operation.URL_FIN;

                const IsDownload = this.Download_File_FIN(URL, FIN.Name);

                if (!IsDownload) throw new Error('No file Download');
              } else {
                throw "ERROR";
              }


            } else {

              const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
              })

              Toast.fire({
                icon: 'warning',
                title: '¡No existe una última versión aprobada del Proceso !'
              })

            }

          }


        } catch (e) {

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar la última versión aprobada del Proceso, informa a tu supervisor!'
          })

        }
      }
    })


  }

  // ============== FUNCTION FOR DOWNLOAD FILE FIN ==============\\
  private async Download_File_FIN(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
      const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
      ProgressModal.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Table.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Proceso descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el proceso, informe a su supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  //-================== FUNCTIONS FOR PERMISSIONS ==================-\\
  public UserRoleIn(Permissions: tpermissionFolderFIN[], contextPermissions?: Permission_Folder_FIN): boolean {
    const list = contextPermissions?.Permission || this.Permission_FMF.Permission;

    if (!list) return false;

    for (const Role of list) {
      const PermissionsFound = Permissions.find((p: tpermissionFolderFIN) => {
        return (p.toUpperCase() === Role.toUpperCase());
      })
      if (PermissionsFound) {
        return true;
      }

    }

    return false;

  }

  //-================ FUNCTION FOR MODAL HELP ================-\\
  public ToggleModalHelp(CloseOrOpen: boolean): void {
    const ModalIconsHelp = document.getElementById('ModalIconsHelp') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp.classList.add('active') : ModalIconsHelp.classList.remove('active');
  }

  //-================== FUNCTIONS FOR RETURN TOTAL TASK ==================-\\
  public Total_Task(): string {
    return this.All_Task_FIN > 99 ? `99+` : `${this.All_Task_FIN}`;
  }

  //-===================== FUNCTION FOR SEE CONTRIBUTIONS =====================-\\
  public See_FIN_Contributions(): void {
    window.open(`${URLs.URLINDEX}/Dashboard/FIN/FlowMonitoringFIN`)
  }


  private Poll_OCR_Status(uploadedFiles: any[]): void {
    let attempts = 0;
    const maxAttempts = 60; // 5 minutos aprox
    const total = uploadedFiles.length;
    const IDs = uploadedFiles.map((u: any) => u.ID_WF).filter((id: any) => !!id);

    // Crear mapas de códigos y nombres originales
    const originalCodesMap = new Map<number, string>();
    const originalNamesMap = new Map<number, string>();
    uploadedFiles.forEach((u: any) => {
      const id = Number(u.ID_WF);
      if (u.Name) {
        originalNamesMap.set(id, u.Name);
        const parts = u.Name.split('_');
        if (parts.length > 1) {
          originalCodesMap.set(id, parts[0]);
        } else {
          originalCodesMap.set(id, u.Name.split('.')[0]); // Por si acaso
        }
      }
    });

    const interval = setInterval(() => {
      attempts++;
      if (attempts > maxAttempts) {
        clearInterval(interval);
        return;
      }

      this.masterService.Get_Massive_OCR_Status(this.FIN_LIB_SLUG, IDs).subscribe({
        next: (res: any) => {
          if (res.success && res.operation.finished) {
            clearInterval(interval);

            let renamedCount = 0;
            let keptCount = 0;

            res.operation.records.forEach((record: any) => {
              const id = Number(record.ID_WF);
              const originalCode = originalCodesMap.get(id);
              const originalName = originalNamesMap.get(id);

              const codeChanged = record.code && record.code !== originalCode;
              const nameChanged = record.name && originalName && record.name.toLowerCase() !== originalName.toLowerCase();

              if (codeChanged || nameChanged) {
                renamedCount++;
              } else {
                keptCount++;
              }
            });

            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: 'Procesamiento Completado',
              html: `
                <div style="text-align:left; font-size: 13px;">
                  <p>Se procesaron <b>${total}</b> archivo(s):</p>
                  <ul style="margin-left: 15px;">
                    <li><b>${renamedCount}</b> renombrados.</li>
                    <li><b>${keptCount}</b> sin cambios.</li>
                  </ul>
                </div>
              `,
              showConfirmButton: false,
              timer: 8000,
              timerProgressBar: true
            });
            this.SeeFolder_BreadCrum(this.NumberTopL);
          }
        },
        error: () => clearInterval(interval)
      });
    }, 5000);
  }

  private Poll_Single_OCR_Status(ID_WF: number, originalCode: string, originalName: string): void {
    let attempts = 0;
    const maxAttempts = 60; // 5 minutos aprox

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    });

    Toast.fire({
      icon: 'info',
      title: 'Verificando folio de archivo...'
    });

    const interval = setInterval(() => {
      attempts++;
      if (attempts > maxAttempts) {
        clearInterval(interval);
        Toast.fire({
          icon: 'warning',
          title: 'Tiempo de espera agotado para verificación de folio'
        });
        return;
      }

      this.masterService.Get_Massive_OCR_Status(this.FIN_LIB_SLUG, [ID_WF]).subscribe({
        next: (res: any) => {
          if (res.success && res.operation.finished) {
            clearInterval(interval);
            const record = res.operation.records[0];

            const codeChanged = record && record.code && record.code !== originalCode;
            const nameChanged = record && record.name && originalName && record.name.toLowerCase() !== originalName.toLowerCase();

            if (codeChanged || nameChanged) {
              Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Archivo renombrado con el folio: ${record.code}`,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true
              });
            } else {
              Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'info',
                title: 'Archivo no renombrado',
                text: 'No se detectó un folio válido en el contenido.',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true
              });
            }
            this.SeeFolder_BreadCrum(this.NumberTopL);
          }
        },
        error: () => clearInterval(interval)
      });
    }, 5000);
  }


  //-===================== FUNCTION FOR VERIFY ANNEXE ENCRYPTED =====================-\\
  public async checkAnnexeIsEncrypted(file: FILE_CAP): Promise<boolean> {
    try {

      const File_FormData = new FormData();
      File_FormData.append('File', file.FileData, file.FileName);

      const resVerifyFile: Response_FIN = await firstValueFrom(this.Service_FIN.Upload_CheckFileEncrypt(File_FormData));
      return resVerifyFile.operation;

    } catch (error) {

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No se pudo verificar este archivo',
        text: '¡intente cargar nuevamente el archivo, si el problema persiste notifique a su supervisor!',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }
  }

  //-===================== DRAG AND DROP FUNCTIONS =====================-\\

  /**
   * Inicia el evento de arrastre capturando los datos del elemento arrastrado
   */
  public OnDragStart(event: DragEvent, item: FILE_FIN): void {
    const isItemSelected = this.SelectedALL_FAF_FIN?.some((s: any) => s.ID === item.ID);
    if (!isItemSelected) {
      this.SelectedALL_FAF_FIN = [item as any];
    }
    this.draggedItems = this.SelectedALL_FAF_FIN.map((s: any) => ({
      ...s,
      parentPath: this.Route_Level_Global
    }));

    const dragData = {
      multiple: this.draggedItems.length > 1,
      count: this.draggedItems.length,
      id: item.ID,
      isDirectory: item.Directory
    };
    event.dataTransfer!.effectAllowed = 'move';
    event.dataTransfer!.setData('application/json', JSON.stringify(dragData));

    if (this.draggedItems.length > 1) {
      const dragGhost = document.createElement('div');
      dragGhost.style.position = 'absolute';
      dragGhost.style.top = '-1000px';
      dragGhost.style.background = '#20a8e1';
      dragGhost.style.color = 'white';
      dragGhost.style.padding = '8px 12px';
      dragGhost.style.borderRadius = '4px';
      dragGhost.style.fontFamily = 'Arial, sans-serif';
      dragGhost.style.fontSize = '14px';
      dragGhost.innerHTML = `<i class="fa-solid fa-copy" style="margin-right:8px;"></i>Moviendo ${this.draggedItems.length} elementos`;
      document.body.appendChild(dragGhost);
      event.dataTransfer!.setDragImage(dragGhost, 0, 0);
      setTimeout(() => document.body.removeChild(dragGhost), 100);
    }
  }

  /**
   * Controla el comportamiento al arrastrar sobre un elemento
   */
  public OnDragOver(event: DragEvent, item: FILE_FIN): void {
    event.preventDefault();
    this.HandleAutoScroll(event.clientY, event.clientX);
    event.stopPropagation();

    // Solo permitir soltar en carpetas
    if (item.Directory) {
      event.dataTransfer!.dropEffect = 'move';
      this.dragOverFolderId = item.ID;
    }
  }

  /**
   * Limpia el estado visual cuando se deja de arrastrar sobre un elemento
   */
  public OnDragLeave(event: DragEvent, item: any): void {
    if (this.dragOverFolderId === item.ID) {
      this.dragOverFolderId = null;
    }
  }

  /**
   * Maneja el fin del arrastre (drop exitoso, cancelado o soltado fuera).
   */
  public OnDragEnd(event: DragEvent): void {
    this.draggedItems = [];
    this.dragOverFolderId = null;
    this.isScrolling = false;
    this.scrollDirection = 0;
    this.scrollSpeed = 0;

    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }

  /**
   * Ejecuta el movimiento del elemento cuando se suelta sobre una carpeta en la tabla
   */
  public async OnDrop(event: DragEvent, targetItem: FILE_FIN): Promise<void> {
    event.preventDefault();
    this.dragOverFolderId = null;

    if (!this.draggedItems || this.draggedItems.length === 0 || !targetItem.Directory) {
      return;
    }

    const isTargetInSelection = this.draggedItems.some(i => i.ID === targetItem.ID);
    if (isTargetInSelection) {
      Swal.fire({
        icon: 'warning',
        title: 'Movimiento no permitido',
        text: `No puedes mover un elemento dentro de sí mismo o a la selección actual.`,
        confirmButtonColor: this.ColorConfirm
      });
      this.draggedItems = [];
      return;
    }

    const destPath = targetItem.Path || `${this.Route_Level_Global}${this.Route_Level_Global ? '/' : ''}${targetItem.ID}§${targetItem.Code || targetItem.Name}`;

    const success = await this.MoveItemsToDestination(this.draggedItems, targetItem, destPath);
    if (success) {
      this.OnFolderClick(null as any, targetItem);
      this.SelectedALL_FAF_FIN = [];
      this.IsMultiSelectMode = false;
    }
    this.draggedItems = [];
  }

  private IsRedundantMove(sourceItem: any, destinationPath: string, destinationName: string, silent: boolean = false): boolean {
    const sourceName = sourceItem.Code || sourceItem.Name || sourceItem.name;
    const normalizedSourceParentPath = (sourceItem.parentPath || "").replace(/\/+$/g, '').toLowerCase();
    const normalizedDestinationPath = destinationPath.replace(/\/+$/g, '').toLowerCase();

    if (normalizedSourceParentPath === normalizedDestinationPath) {
      if (!silent) {
        Swal.fire({
          icon: 'info',
          title: 'Movimiento no necesario',
          text: `El elemento "${sourceName}" ya se encuentra en "${destinationName}".`,
          confirmButtonColor: this.ColorConfirm
        });
      }
      return true;
    }
    return false;
  }

  public async MoveItemsToDestination(sourceItems: any[], targetItem: any, destinationPath: string): Promise<boolean> {
    if (!sourceItems || sourceItems.length === 0) return false;

    const destinationId = targetItem?.ID !== undefined ? targetItem.ID : (parseInt(targetItem?.split('§')[0]) || 0);
    const destinationName = targetItem?.Name || targetItem?.split('§').pop() || 'RAIZ';

    const validItemsToMove = [];
    let omittedCount = 0;

    for (const sourceItem of sourceItems) {
      const sourceId = sourceItem.ID || sourceItem.id;
      const isDirectory = sourceItem.Directory === true || sourceItem.isDirectory === true || sourceItem.type === 'folder';
      
      const permissionKey = isDirectory ? this.PermissionFIN.moveFolder : this.PermissionFIN.moveFile;
      const idFolder = sourceItem.ID_Folder ?? sourceItem.idFolder;

      let permissionsToCheck = this.Permission_FMF;
      const targetFolderId = isDirectory ? Number(sourceId) : Number(idFolder);

      if (targetFolderId > 0 && targetFolderId !== this.ID_Folder_Level) {
        try {
          permissionsToCheck = await this.PermissionFolder.GetPermissionsInFolderFIN(this.ID_User_BD, targetFolderId);
        } catch (error) {
          console.error("Error obteniendo permisos de destino", error);
          permissionsToCheck = { Permission: [] } as any;
        }
      }

      const isAuthorized = this.UserRoleIn([permissionKey], permissionsToCheck) ||
        this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorFIN]);

      if (!isAuthorized) {
        omittedCount++;
        continue;
      }

      if (!this.IsRedundantMove(sourceItem, destinationPath, destinationName, true)) {
         if (!(isDirectory && sourceId === destinationId)) {
            validItemsToMove.push(sourceItem);
         }
      }
    }

    if (omittedCount > 0 && validItemsToMove.length === 0) {
       Swal.fire({
          icon: 'warning',
          title: 'Permisos insuficientes',
          text: 'No tienes permisos para mover los elementos seleccionados.',
          confirmButtonColor: this.ColorConfirm
       });
       return false;
    }

    if (validItemsToMove.length === 0) {
       Swal.fire({
          icon: 'info',
          title: 'Movimiento no necesario',
          text: `Todos los elementos seleccionados ya están en el destino o no son válidos para moverse.`,
          confirmButtonColor: this.ColorConfirm
       });
       return false;
    }

    const moveConfirm = await Swal.fire({
      title: '¿Confirmar movimiento?',
      text: validItemsToMove.length === 1 
          ? `¿Deseas mover "${validItemsToMove[0].Code || validItemsToMove[0].Name || validItemsToMove[0].name}" a "${destinationName}"?${omittedCount > 0 ? `\n\n(Se omitirán ${omittedCount} elementos sin permisos)` : ''}`
          : `¿Deseas mover ${validItemsToMove.length} elementos a "${destinationName}"?${omittedCount > 0 ? `\n\n(Se omitirán ${omittedCount} elementos sin permisos)` : ''}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm || '#20a8e1',
      cancelButtonColor: '#ff7043',
      confirmButtonText: 'Sí, mover',
      cancelButtonText: 'Cancelar'
    });

    if (!moveConfirm.isConfirmed) {
      return false;
    }

    let successCount = 0;
    try {
      Swal.fire({
        title: 'Moviendo elementos...',
        html: `
          <div style="font-size: 18px; font-weight: 600; color: #475569; margin-bottom: 15px;">
            Progreso: <b>0</b> / <b>${validItemsToMove.length}</b>
          </div>
          <div class="loader-container" style="display: flex; justify-content: center; align-items: center; padding: 10px;">
            <div class="custom-spinner"></div>
          </div>
          <style>
            .custom-spinner {
              width: 32px;
              height: 32px;
              border: 3px solid rgba(32, 168, 225, 0.1);
              border-radius: 50%;
              border-top-color: #20a8e1;
              animation: spin 1s ease-in-out infinite;
            }
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          </style>
        `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false
      });

      for (let i = 0; i < validItemsToMove.length; i++) {
        const sourceItem = validItemsToMove[i];
        const sourceId = sourceItem.ID || sourceItem.id;
        const isDirectory = sourceItem.Directory === true || sourceItem.isDirectory === true || sourceItem.type === 'folder';

        let moveRequest: Observable<Response_FIN>;

        if (isDirectory) {
          const moveData = {
            ID_Folder_Src: sourceId,
            ID_Folder_Des: destinationId
          };
          moveRequest = this.Service_FIN.Move_Dir_To_Dir_FIN(moveData);
        } else {
          const moveData = {
            path: destinationPath,
            ID_WF: sourceItem.ID_WF || sourceId
          };
          moveRequest = this.Service_FIN.Move_Process_FIN(moveData);
        }

        const response: any = await firstValueFrom(moveRequest);
        if (response.success) {
           successCount++;
           const swalHtml = Swal.getHtmlContainer();
           if (swalHtml) {
              const b = swalHtml.querySelector('b');
              if (b) b.textContent = successCount.toString();
           }
        }
        await new Promise(resolve => setTimeout(resolve, 350));
      }

      Swal.fire({
        icon: 'success',
        title: 'Movimiento completado',
        text: `¡Se movieron ${successCount} de ${validItemsToMove.length} elementos a "${destinationName}"!`,
        confirmButtonColor: this.ColorConfirm,
        timer: 2000
      });
      return successCount > 0;

    } catch (error: any) {
      console.error('Error en drag and drop:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error al mover',
        text: error.error?.message || error.message || 'Ocurrió un error durante el movimiento',
        confirmButtonColor: this.ColorConfirm
      });
      return successCount > 0;
    }
  }

  public GetBreadcrumbDropPath(index: number): string {
    if (index <= 0) return '';
    return this.Header_Routes.slice(1, index + 1).join('/');
  }

  public OnBreadcrumbDragOver(event: DragEvent, index: number): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.draggedItems || this.draggedItems.length === 0) return;

    const containsFile = this.draggedItems.some(i => !i.Directory && i.type !== 'folder');
    const destinationPath = this.GetBreadcrumbDropPath(index);

    if (!containsFile || destinationPath !== '') {
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'move';
      }
      this.dragOverBreadcrumbIndex = index;
    } else {
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'none';
      }
    }
  }

  public OnBreadcrumbDragLeave(event: DragEvent, index: number): void {
    if (this.dragOverBreadcrumbIndex === index) {
      this.dragOverBreadcrumbIndex = -1;
    }
  }

  public async OnBreadcrumbDrop(event: DragEvent, index: number): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    this.dragOverBreadcrumbIndex = -1;

    if (!this.draggedItems || this.draggedItems.length === 0) return;

    // --- VALIDACIÓN RAIZ PARA BREADCRUMB ---
    const containsFile = this.draggedItems.some(i => !i.Directory);
    if (index === 0 && containsFile) {
      Swal.fire({
        icon: 'warning',
        title: 'Movimiento no permitido',
        text: 'En la raíz solo se permiten carpetas.',
        confirmButtonColor: '#20a8e1'
      });
      return;
    }



    const destinationPath = this.GetBreadcrumbDropPath(index);
    const targetFolderStr = this.Header_Routes[index];
    const destinationName = targetFolderStr.split('§').pop() || 'RAIZ';

    const success = await this.MoveItemsToDestination(this.draggedItems, targetFolderStr, destinationPath);
    if (success) {
      // Navegar al breadcrumb destino tras el movimiento exitoso
      this.SeeFolder_BreadCrum(index);
      this.SelectedALL_FAF_FIN = [];
      this.IsMultiSelectMode = false;
    }
    this.draggedItems = [];
  }



  public async OnFolderClick(event: any, folder: FILE_FIN): Promise<void> {
    if (event) event.stopPropagation();
    if (!this.LoadPage) return; // Evitar clicks repetidos rápidos mientras carga

    if (folder.Directory) {
      // Navigate into folder
      const index = this.Header_Routes.length;
      this.Header_Routes.push(`${folder.ID}§${folder.Name}`);
      this.NumberTopL = this.NumberTopL + 1;
      this.Route_Level_Global = this.Route_Level_Global ? `${this.Route_Level_Global}/${folder.ID}§${folder.Name}` : `${folder.ID}§${folder.Name}`;
      this.CheckUserPermissionFolder(folder.ID, this.Route_Level_Global);
    }
  }

  /**
   * Verifica si un elemento es una carpeta
   */
  public IsFolder(item: FILE_FIN): boolean {
    return item.Directory === true;
  }

  /**
   * Verifica si un elemento está siendo arrastrado sobre él
   */
  public IsDraggedOver(item: FILE_FIN): boolean {
    return this.dragOverFolderId === item.ID;
  }

  // --- MÉTODOS PARA EL CONTEXT MENU ---
  public SelectForMove(item: FILE_FIN): void {
    this.FFIN_Select_CM = item;
    const isMultiple = this.IsMultiSelectMode && 
                       Array.isArray(this.SelectedALL_FAF_FIN) && 
                       this.SelectedALL_FAF_FIN.some((i: any) => i.ID === item.ID);

    if (isMultiple) {
      this.selectedItemsToMove = this.SelectedALL_FAF_FIN.map((i: any) => ({
        ID: i.ID,
        ID_WF: i.ID_WF,
        Name: i.Name,
        Code: i.Code,
        Directory: i.Directory,
        Path: i.Path,
        parentPath: this.Route_Level_Global,
        ID_Folder: i.ID_Folder
      }));
      this.selectedItemToMove = {
        ID: item.ID,
        ID_WF: item.ID_WF,
        Name: item.Name,
        Code: item.Code,
        Directory: item.Directory,
        Path: item.Path,
        parentPath: this.Route_Level_Global,
        ID_Folder: item.ID_Folder
      };
    } else {
      const singleItem = {
        ID: item.ID,
        ID_WF: item.ID_WF,
        Name: item.Name,
        Code: item.Code,
        Directory: item.Directory,
        Path: item.Path,
        parentPath: this.Route_Level_Global,
        ID_Folder: item.ID_Folder
      };
      this.selectedItemsToMove = [singleItem];
      this.selectedItemToMove = singleItem;
    }

    this.Right_Sidebar_Visible = true;
  }

  public async OnPerformMove(event: { items: any[], destinationNode: any }) {
    const { items, destinationNode } = event;
    const destPath = String(destinationNode.data || '');
    const lastSegment = destPath ? destPath.split('/').pop() : '';

    this.Right_Sidebar_Visible = false;

    const success = await this.MoveItemsToDestination(items, lastSegment, destPath);
    if (success) {
      this.GetInformationDiretory(this.Route_Level_Global);
      this.SelectedALL_FAF_FIN = [];
      this.IsMultiSelectMode = false;
    }
  }

  public ShowSide(show: boolean): void {
    this.Right_Sidebar_Visible = show;
  }

  public IsMove(event: any): void {
    if (event) {
      this.GetInformationDiretory(this.Route_Level_Global);
    }
  }

  //&===================== END FUNCTIONS FOR GENERAL SYSTEM =====================&\\
}
